interface Locale {
  [key: string]: {
    en_US: string;
    ar_SA: string;
    tr_TR: string;
    ru_RU: string;
    uz_UZ: string; // 乌兹别克语
    ur_PK?: string; // 乌尔都语
    pt_BR?: string; // 葡萄牙语(巴西)
    id_ID?: string; // 印度尼西亚语
    fa_IR?: string; // 波斯语
    zh_CN?: string;
    th_TH?: string;
    vi_VN?: string;
    es_ES?: string;
  };
}

const locales: Locale = {
  语言: {
    en_US: 'English',
    ar_SA: 'لغة',
    tr_TR: 'dil',
    pt_BR: 'Idioma',
    id_ID: 'Bahasa',
    ru_RU: 'Язык',
    uz_UZ: 'Til',
    fa_IR: 'زبان',
    ur_PK: 'زبان',
  },
  '请求地址异常，请检查': {
    en_US: 'The request address is abnormal, please check',
    ar_SA: 'عنوان الطلب غير طبيعي، يرجى التحقق',
    tr_TR: 'İstek adresi anormal, lütfen kontrol edin',
    pt_BR: 'O endereço da solicitação é anormal, por favor, verifique',
    id_ID: 'Alamat permintaan tidak normal, silakan periksa',
    ru_RU: 'Адрес запроса некорректен, пожалуйста, проверьте',
    uz_UZ: 'So‘rov manzili g‘ayritabiiy, tekshiring',
    fa_IR: 'آدرس درخواست غیر عادی است، لطفاً بررسی کنید',
    ur_PK: 'درخواست آدرس نامعتبر است، لطفاً تائید کنید',
  },
  '请求网络异常，请稍后': {
    en_US: 'Request network exception, please wait.',
    ar_SA: 'طلب استثناء الشبكة، يرجى الانتظار.',
    tr_TR: 'Ağ istisnası isteyin, lütfen bekleyin.',
    pt_BR: 'Exceção de rede na solicitação, por favor, aguarde.',
    id_ID: 'Jaringan permintaan bermasalah, silakan tunggu.',
    ru_RU: 'Исключение сети запроса, пожалуйста, подождите.',
    uz_UZ: 'So‘rov tarmog‘ida xatolik, iltimos, kuting.',
    fa_IR: 'استثناء شبکه درخواست، لطفاً صبر کنید.',
    ur_PK: 'درخواست اینترنتی خطا دارد، لطفاً منتظر بمانید.',
  },
  请求失败: {
    en_US: 'Request failed',
    ar_SA: 'فشل الطلب',
    tr_TR: 'İstek başarısız oldu',
    pt_BR: 'Solicitação falhou',
    id_ID: 'Permintaan gagal',
    ru_RU: 'Запрос не удался',
    uz_UZ: 'So‘rov muvaffaqiyatsiz bo‘ldi',
    fa_IR: 'درخواست ناموفق بود',
    ur_PK: 'درخواست ناچیز'
  },
  搜索: {
    en_US: 'Search',
    ar_SA: 'يبحث',
    tr_TR: 'Ara',
    pt_BR: 'Pesquisar',
    id_ID: 'Cari',
    ru_RU: 'Поиск',
    uz_UZ: 'Qidirish',
    fa_IR: 'جستجو',
    ur_PK: 'تلاش'
  },
  '搜索姓名/ID': {
    en_US: 'Search for name / ID',
    ar_SA: 'يبحث عن الاسم / الهوية',
    tr_TR: 'Isim / ID aramak',
    pt_BR: 'Pesquise por nome / ID',
    id_ID: 'Cari nama / ID',
    ru_RU: 'Поиск по имени / ID',
    uz_UZ: 'Ism / ID bo‘yicha qidirish',
    fa_IR: 'جستجو بر اساس نام/شناسه',
    ur_PK: 'جستجو براساس نام / شناسه'
  },
  加入: {
    en_US: 'Join',
    ar_SA: 'إنضمام',
    tr_TR: 'Katılmak',
    pt_BR: 'Junte-se',
    id_ID: 'Bergabung',
    ru_RU: 'Присоединиться',
    uz_UZ: 'Qo‘shilish',
    fa_IR: 'عضویت',
    ur_PK: 'پیوستن'
  },
  提示: {
    en_US: 'Tips',
    ar_SA: 'إشعار',
    tr_TR: 'İPUÇLARI',
    pt_BR: 'Dicas',
    id_ID: 'Petunjuk',
    ru_RU: 'Подсказки',
    uz_UZ: 'Maslahatlar',
    fa_IR: 'راهنماها',
    ur_PK: 'نکات'
  },
  已同意: {
    en_US: 'Agreed',
    ar_SA: 'موافق',
    tr_TR: 'Onaylandı',
    pt_BR: 'Acordado',
    id_ID: 'Disetujui',
    ru_RU: 'Согласовано',
    uz_UZ: 'Qabul qilindi',
    fa_IR: 'تایید شده',
    ur_PK: 'اتفاق کیا۔'
  },
  已拒绝: {
    en_US: 'Rejected',
    ar_SA: 'مرفوض',
    tr_TR: 'Reddedildi',
    pt_BR: 'Rejeitado',
    id_ID: 'Ditolak',
    ru_RU: 'Отклонено',
    uz_UZ: 'Rad etildi',
    fa_IR: 'رد شده',
    ur_PK: 'مسترد'
  },
  拒绝: {
    en_US: 'Refuse',
    ar_SA: 'يرفض',
    tr_TR: 'Reddet',
    pt_BR: 'Recusar',
    id_ID: 'Tolak',
    ru_RU: 'Отклонить',
    uz_UZ: 'Rad etish',
    fa_IR: 'رد کردن',
    ur_PK: 'انکار'
  },
  同意: {
    en_US: 'Agree',
    ar_SA: 'موافقة',
    tr_TR: 'Onayla',
    pt_BR: 'Aceitar',
    id_ID: 'Setuju',
    ru_RU: 'Согласиться',
    uz_UZ: 'Rozilik bildirish',
    fa_IR: 'تایید کردن',
    ur_PK: 'متفق '
  },
  会员: {
    en_US: 'Member',
    ar_SA: 'عضو',
    tr_TR: 'Üye',
    pt_BR: 'Membro',
    id_ID: 'Anggota',
    ru_RU: 'Член',
    uz_UZ: "A'zo",
    fa_IR: 'عضو',
    ur_PK: 'ممبر'
  },
  '邀请': {
    en_US: 'Invite',
    ar_SA: 'مشاركة',
    tr_TR: 'davet et',
    pt_BR: 'Convidar',
    id_ID: 'Undang',
    ru_RU: 'Пригласить',
    uz_UZ: 'Taklif qilish',
    fa_IR: 'دعوت',
    ur_PK: 'دعوت دیں'
  },
  '没有更多了': {
    en_US: 'No more',
    ar_SA: 'لا يوجد المزيد',
    tr_TR: 'Daha fazla yok',
    pt_BR: 'Não há mais',
    id_ID: 'Tidak ada lagi',
    ru_RU: 'Больше нет',
    uz_UZ: 'Boshqa narsa yo‘q',
    fa_IR: 'دیگر چیزی وجود ندارد',
    ur_PK: 'مزید کچھ نہیں'
  },
  '同意成功': {
    en_US: 'Agree successfully',
    ar_SA: 'تم الموافقة بنجاح',
    tr_TR: 'Kabul edildi',
    pt_BR: 'Aceito com sucesso',
    id_ID: 'Disetujui berhasil',
    ru_RU: 'Успешно согласовано',
    uz_UZ: 'Muvaffaqiyatli tasdiqlandi',
    fa_IR: 'تایید با موفقیت انجام شد',
    ur_PK: 'کامیابی سے منظور'
  },
  '拒绝成功': {
    en_US: 'Reject successfully',
    ar_SA: 'تم الرفض بنجاح',
    tr_TR: 'Reddedildi',
    pt_BR: 'Rejeitado com sucesso',
    id_ID: 'Ditolak berhasil',
    ru_RU: 'Успешно отклонено',
    uz_UZ: 'Muvaffaqiyatli rad etildi',
    fa_IR: 'رد با موفقیت انجام شد',
    ur_PK: 'کامیابی سے مسترد'
  },
  该ID不存在: {
    "en_US": "This ID doesn’t exist.",
    "ar_SA": "هذا الايدي ليس موجودا",
    "tr_TR": "ID mevcut değil",
    "pt_BR": "Este ID não existe.",
    "id_ID": "ID ini tidak ada.",
    "ru_RU": "Этот ID не существует.",
    "uz_UZ": "Ushbu ID mavjud emas.",
    "fa_IR": "این ایدی وجود ندارد",
    ur_PK: 'یہ ID موجود نہیں ہے',
  },
  不能为空: {
    "en_US": "Cannot be empty",
    "ar_SA": "لا يمكن أن تكون فارغة",
    "tr_TR": "Boş olamaz",
    "pt_BR": "Não pode ser vazio",
    "id_ID": "Tidak boleh kosong",
    "ru_RU": "Не может быть пустым",
    "uz_UZ": "To‘xtatilmagan",
    "fa_IR": "نمی‌تواند خالی باشد",
    ur_PK: 'خالی نہیں ہو سکتا'
  },
  查询: {
    "en_US": "Verify",
    "ar_SA": "التحقيق",
    "tr_TR": "Sorgula",
    "pt_BR": "Verificar",
    "id_ID": "Verifikasi",
    "ru_RU": "Проверить",
    "uz_UZ": "Tasdiqlash",
    "fa_IR": "تایید",
    ur_PK: 'تصدیق کریں'
  },
  热门: {
    "en_US": "Hot",
    "ar_SA": "شائع",
    "tr_TR": "Popüler",
    "pt_BR": "Popular",
    "id_ID": "Populer",
    "ru_RU": "Популярные",
    "uz_UZ": "Popular",
    "fa_IR": "پربازدیده",
    ur_PK: 'مشہور',
  },
  所有: {
    "en_US": "All",
    "ar_SA": "جميع",
    "tr_TR": "Tümü",
    "pt_BR": "Todos",
    "id_ID": "Semua",
    "ru_RU": "Все",
    "uz_UZ": "Hammasi",
    "fa_IR": "همه",
    ur_PK: 'تمام'
  },
  帮助: {
    "en_US": "Help",
    "ar_SA": "ساعد",
    "tr_TR": "yardım",
    "pt_BR": "Ajuda",
    "id_ID": "Bantuan",
    "ru_RU": "Помощь",
    "uz_UZ": "Yordam",
    "fa_IR": "راهنما",
    ur_PK: 'مدد',
  },
  请选择国家: {
    "en_US": "Please select a country",
    "ar_SA": "رجاء قم بإختيار دوله",
    "tr_TR": "Lütfen bir ülke seçin",
    "pt_BR": "Por favor, selecione um país",
    "id_ID": "Silakan pilih negara",
    "ru_RU": "Пожалуйста, выберите страну",
    "uz_UZ": "Tilni tanlang",
    "fa_IR": "لطفاً دلیلی را انتخاب کنید",
    ur_PK: 'براہ کرم ملک منتخب کریں',
  },
  请选择支付方式: {
    "en_US": "Please select mode of payment",
    "ar_SA": "الرجاء تحديد طريقة الدفع",
    "tr_TR": "Lütfen ödeme yöntemini seçin",
    "pt_BR": "Por favor, selecione o modo de pagamento",
    "id_ID": "Silakan pilih metode pembayaran",
    "ru_RU": "Пожалуйста, выберите способ оплаты",
    "uz_UZ": "To‘lov uslubi tanlang",
    "fa_IR": "لطفاً روش پرداخت را انتخاب کنید",
    ur_PK: 'براہ کرم ادائیگی کا طریقہ منتخب کریں',
  },
  请选择充值金额: {
    "en_US": "Please enter the recharge amount",
    "ar_SA": "الرجاء إدخال مبلغ إعادة الشحن",
    "tr_TR": "Lütfen yükleme tutarını girin",
    "pt_BR": "Por favor, insira o valor da recarga",
    "id_ID": "Silakan masukkan jumlah isi ulang",
    "ru_RU": "Пожалуйста, введите сумму пополнения",
    "uz_UZ": "Pulni qo‘shish miqdorida kiriting",
    "fa_IR": "لطفاً مبلغی که می‌خواهید شارژ کنید را وارد کنید",
    ur_PK: 'براہ کرم ریچارج کی رقم درج کریں'
  },
  请选择同意条款: {
    "en_US": "Please agree to the terms",
    "ar_SA": "الرجاء الموافقة على الشروط",
    "tr_TR": "Lütfen şartları kabul etmeyi seçin",
    "pt_BR": "Por favor, concorde com os termos",
    "id_ID": "Silakan setujui syarat dan ketentuan",
    "ru_RU": "Пожалуйста, подтвердите условия",
    "uz_UZ": "Shartnomani qabul qilishga ruxsat berish",
    "fa_IR": "لطفاً شرایط را موافقت کنید",
    ur_PK: 'براہ کرم شرائط سے اتفاق کریں'
  },
  成功: {
    "en_US": "The operation was successful",
    "ar_SA": "العملية كانت ناجحه",
    "tr_TR": "İşlem Başarılı Oldu",
    "pt_BR": "A operação foi bem-sucedida",
    "id_ID": "Operasi berhasil",
    "ru_RU": "Операция выполнена успешно",
    "uz_UZ": "Operatsiya muvaffaqiyatli amalga oshirildi",
    "fa_IR": "عملیات موفقیت آمیز بود",
    ur_PK: 'عمل کامیابی سے مکمل ہوا'
  },
  登录: {
    en_US: "Log in",
    ar_SA: "تسجيل الدخول",
    tr_TR: "Giriş Yap",
    pt_BR: "Entrar",
    id_ID: "Masuk",
    ru_RU: "Войти",
    uz_UZ: "Kirish",
    fa_IR: "ورود",
    ur_PK: "لاگ ان کریں"
  },
  用户名: {
    en_US: "UserName",
    ar_SA: "اسم المستخدم",
    tr_TR: "Kullanıcı Adı",
    pt_BR: "Nome de Usuário",
    id_ID: "Nama Pengguna",
    ru_RU: "Имя пользователя",
    uz_UZ: "Ism-manzil",
    fa_IR: "نام کاربری",
    ur_PK: "صارف کا نام"
  },
  用户名不能为空: {
    en_US: "User name cannot be empty",
    ar_SA: "اسم المستخدم لا يمكن ان يكون فارغ",
    tr_TR: "Kullanıcı adı boş olamaz",
    pt_BR: "O nome de usuário não pode ser vazio",
    id_ID: "Nama pengguna tidak boleh kosong",
    ru_RU: "Имя пользователя не может быть пустым",
    uz_UZ: "Ism-manzil to‘xtatilmagan",
    fa_IR: "نام کاربری نمی‌تواند خالی باشد",
    ur_PK: "صارف کا نام خالی نہیں ہو سکتا"
  },
  密码: {
    en_US: "Password",
    ar_SA: "كلمة المرور",
    tr_TR: "Parola",
    pt_BR: "Senha",
    id_ID: "Kata Sandi",
    ru_RU: "Пароль",
    uz_UZ: "Parol",
    fa_IR: "رمز عبور",
    ur_PK: "پاس ورڈ"
  },
  密码不能为空: {
    en_US: "Password cannot be empty",
    ar_SA: "كلمة المرور لا يمكن ان تكون فارغة",
    tr_TR: "Şifre boş olamaz",
    pt_BR: "A senha não pode ser vazia",
    id_ID: "Kata sandi tidak boleh kosong",
    ru_RU: "Пароль не может быть пустым",
    uz_UZ: "Parol to‘xtatilmagan",
    fa_IR: "رمز عبور نمی‌تواند خالی باشد",
    ur_PK: "پاس ورڈ خالی نہیں ہو سکتا"
  },
  支付: {
    en_US: 'Payment',
    ar_SA: 'دفع',
    tr_TR: 'Ödeme',
    pt_BR: 'Pagamento',
    id_ID: 'Pembayaran',
    ru_RU: 'Оплата',
    uz_UZ: 'To‘lov',
    fa_IR: 'پرداخت',
    ur_PK: 'ادائیگی'
  },
  支付成功: {
    en_US: 'Payment successful',
    ar_SA: 'تم الدفع بنجاح',
    tr_TR: 'Ödeme başarılı',
    pt_BR: 'Pagamento bem-sucedido',
    id_ID: 'Pembayaran berhasil',
    ru_RU: 'Оплата прошла успешно',
    uz_UZ: 'To‘lov muvaffaqiyatli',
    fa_IR: 'پرداخت موفق',
    ur_PK: 'ادائیگی کامیاب'
  },
  处理中: {
    en_US: 'Processing',
    ar_SA: 'قيد المعالجة',
    tr_TR: 'İşleniyor',
    pt_BR: 'Processando',
    id_ID: 'Sedang diproses',
    ru_RU: 'Обрабатывается',
    uz_UZ: 'Bajarilmoqda',
    fa_IR: 'در حال انجام',
    ur_PK: 'پروسیسنگ'
  },
  支付失败: {
    en_US: 'Payment failed',
    ar_SA: 'فشل الدفع',
    tr_TR: 'Ödeme başarısız',
    pt_BR: 'Pagamento falhou',
    id_ID: 'Pembayaran gagal',
    ru_RU: 'Оплата не удалась',
    uz_UZ: 'To‘lov muvaffaqiyatsiz',
    fa_IR: 'پرداخت ناموفق',
    ur_PK: 'ادائیگی ناکام'
  },
  订单关闭: {
    en_US: 'Order closed',
    ar_SA: 'تم إغلاق الطلب',
    tr_TR: 'Sipariş kapatıldı',
    pt_BR: 'Pedido fechado',
    id_ID: 'Pesanan ditutup',
    ru_RU: 'Заказ закрыт',
    uz_UZ: 'Buyurtma qutsuq',
    fa_IR: 'سفارش بسته شد',
    ur_PK: 'آرڈر بند'
  },
  支付金额: {
    en_US: 'Payment amount',
    ar_SA: 'مبلغ الدفع',
    tr_TR: 'Ödeme miktarı',
    pt_BR: 'Valor do pagamento',
    id_ID: 'Jumlah pembayaran',
    ru_RU: 'Сумма оплаты',
    uz_UZ: 'To‘lov miqdori',
    fa_IR: 'مبلغ پرداخت',
    ur_PK: 'ادائیگی کی رقم'
  },
  获得金币: {
    en_US: 'Get coins',
    ar_SA: 'الحصول على العملات',
    tr_TR: 'Altın kazan',
    pt_BR: 'Obter moedas',
    id_ID: 'Dapatkan koin',
    ru_RU: 'Получить монеты',
    uz_UZ: 'Koinni olish',
    fa_IR: 'دریافت ارز',
    ur_PK: 'سکے حاصل کریں'
  },
  付款编号: {
    en_US: 'Payment No.',
    ar_SA: 'رقم الدفع',
    tr_TR: 'Ödeme numarası',
    pt_BR: 'Número do pagamento',
    id_ID: 'Nomor pembayaran',
    ru_RU: 'Номер платежа',
    uz_UZ: 'To‘lov raqami',
    fa_IR: 'شماره پرداخت',
    ur_PK: 'ادائیگی نمبر'
  },
  订单编号: {
    en_US: 'Order No.',
    ar_SA: 'رقم الطلب',
    tr_TR: 'Sipariş numarası',
    pt_BR: 'Número do pedido',
    id_ID: 'Nomor pesanan',
    ru_RU: 'Номер заказа',
    uz_UZ: 'Buyurtma raqami',
    fa_IR: 'شماره سفارش',
    ur_PK: 'آرڈر نمبر'
  },
  返回充值: {
    en_US: 'Back to Recharge',
    ar_SA: 'العودة للشحن',
    tr_TR: 'Yükleme sayfası Geri Dön',
    pt_BR: 'Voltar para recarga',
    id_ID: 'Kembali ke isi ulang',
    ru_RU: 'Вернуться к пополнению',
    uz_UZ: 'Qayta to‘lov',
    fa_IR: 'بازگشت به شارژ',
    ur_PK: 'ریچارج پر واپس جائیں'
  },
  联系客服: {
    en_US: 'Contact Customer Service',
    ar_SA: 'اتصل بخدمة العملاء',
    tr_TR: 'Müşteri Hizmetleri ile iletişime geçin',
    pt_BR: 'Contate o atendimento ao cliente',
    id_ID: 'Hubungi layanan pelanggan',
    ru_RU: 'Свяжитесь с службой поддержки',
    uz_UZ: 'Biz bilan aloqa',
    fa_IR: 'تماس با سرویس های پشتیبانی',
    ur_PK: 'کسٹمر سروس سے رابطہ کریں'
  },
  知道了: {
    en_US: 'Got it',
    ar_SA: 'حسنا',
    tr_TR: 'Anladım',
    pt_BR: 'Entendi',
    id_ID: 'Mengerti',
    ru_RU: 'Понял',
    uz_UZ: 'Aniq',
    fa_IR: 'فهمیدم',
    ur_PK: 'سمجھ گیا'
  },
  复制: {
    en_US: 'Copy',
    ar_SA: 'نسخ',
    tr_TR: 'Kopyala',
    pt_BR: 'Copiar',
    id_ID: 'Salin',
    ru_RU: 'Копировать',
    uz_UZ: 'Nusxalash',
    fa_IR: 'کپی',
    ur_PK: 'نقل کریں'
  },
  详情: {
    en_US: 'Details',
    ar_SA: 'تفاصيل',
    tr_TR: 'Ayrıntılar',
    pt_BR: 'Detalhes',
    id_ID: 'Rincian',
    ru_RU: 'Подробности',
    uz_UZ: 'Ma\'lumotlar',
    fa_IR: 'جزئیات',
    ur_PK: 'تفصیلات'
  },
  今日: {
    en_US: 'Today',
    ar_SA: 'اليوم',
    tr_TR: 'Bugün',
    id_ID: 'Hari Ini',
    pt_BR: 'Hoje',
    ru_RU: 'Сегодня',
    uz_UZ: 'Bugun',
    fa_IR: 'امروز',
    ur_PK: 'آج'
  },
  昨日: {
    en_US: 'Yesterday',
    tr_TR: 'Dün',
    ar_SA: 'امس',
    id_ID: 'Kemarin',
    pt_BR: 'Ontem',
    ru_RU: 'Вчера',
    uz_UZ: 'Kecha',
    fa_IR: 'پیش',
    ur_PK: 'کل'
  },
  本周: {
    en_US: 'This Week',
    tr_TR: 'Bu hafta',
    ar_SA: 'الأسبوع الحالي',
    id_ID: 'Minggu Ini',
    pt_BR: 'Esta Semana',
    ru_RU: 'На этой неделе',
    uz_UZ: 'Bu hafta',
    fa_IR: 'هفته اینجا',
    ur_PK: 'اس ہفتہ'
  },
  上周: {
    en_US: 'Last Week',
    tr_TR: 'Geçen hafta',
    ar_SA: 'الأسبوع الماضي',
    id_ID: 'Minggu Lalu',
    pt_BR: 'Semana Passada',
    ru_RU: 'Прошлая неделя',
    uz_UZ: 'O‘tgan hafta',
    fa_IR: 'هفته گذشته',
    ur_PK: 'گزشتہ ہفتہ'
  },
  本月: {
    en_US: 'This Month',
    tr_TR: 'Bu Ay',
    ar_SA: 'الشهر الحالي',
    id_ID: 'Bulan Ini',
    pt_BR: 'Este Mês',
    ru_RU: 'В этом месяце',
    uz_UZ: 'Bu oy',
    fa_IR: 'این ماه',
    ur_PK: 'اس مہینہ'
  },
  上月: {
    en_US: 'Last Month',
    tr_TR: 'Geçen ay',
    ar_SA: 'الشهر الماضي',
    id_ID: 'Bulan Lalu',
    pt_BR: 'Mês Passado',
    ru_RU: 'Прошлый месяц',
    uz_UZ: 'O‘tgan oy',
    fa_IR: 'ماه گذشته',
    ur_PK: 'گزشتہ مہینہ'
  },
  小时: {
    en_US: 'Hours',
    tr_TR: 'Saatler',
    ar_SA: 'ساعد',
    id_ID: 'Jam',
    pt_BR: 'Horas',
    ru_RU: 'Часы',
    uz_UZ: 'Soatlar',
    fa_IR: 'ساعت',
    ur_PK: 'گھنٹے'
  },
  分钟: {
    en_US: 'Minutes',
    tr_TR: 'Dakikalar',
    ar_SA: 'دقيقد',
    id_ID: 'Menit',
    pt_BR: 'Minutos',
    ru_RU: 'Минуты',
    uz_UZ: 'Daqiqalar',
    fa_IR: 'دقیقه',
    ur_PK: 'منٹ'
  },
  秒: {
    en_US: 'Seconds',
    tr_TR: 'Saniyeler',
    ar_SA: 'ثانية',
    id_ID: 'Detik',
    pt_BR: 'Segundos',
    ru_RU: 'Секунды',
    uz_UZ: 'Soniyalar',
    fa_IR: 'ثانیه',
    ur_PK: 'سیکنڈ'
  },
  utc_tips: {
    zh_CN: '基于Utc+3 时区统计数据',
    en_US: 'Based on Utc+3 time zone statistics',
    tr_TR: 'Utc+3 saat dilimi istatistiklerine göre',
    ar_SA: 'استنادًا إلى إحصائيات المنطقة الزمنية Utc+3',
    id_ID: 'Berdasarkan statistik zona waktu Utc+3',
    pt_BR: 'Com base nas estatísticas de fuso horário UTC+3',
    ru_RU: 'На основе статистики часовых поясов Utc+3',
    uz_UZ: 'UTC+3 vaqt zonalari statistikasi asosida',
    fa_IR: 'سنسورهای زمانی بر پایه Utc+3',
    ur_PK: 'Utc+3 ٹائم زون کے اعداد و شمار پر مبنی'
  },
  举报: {
    zh_CN: '举报',
    en_US: 'Report',
    tr_TR: 'Raporla',
    ar_SA: 'التبليغ',
    id_ID: 'Laporkan',
    pt_BR: 'Denunciar',
    ru_RU: 'Пожаловаться',
    uz_UZ: 'Shikoyat',
    fa_IR: 'گزارش',
    ur_PK: 'گزارش کریں'
  },
  举报类型: {
    zh_CN: '举报类型',
    en_US: 'Report Type',
    tr_TR: 'Rapor Türü',
    ar_SA: 'نوع التبليغ',
    id_ID: 'Jenis laporan',
    pt_BR: 'Tipo de denúncia',
    ru_RU: 'Тип жалобы',
    uz_UZ: 'Shikoyat turini',
    fa_IR: 'نوع گزارش',
    ur_PK: 'گزارش کی ترتیب'
  },
  描述: {
    zh_CN: '描述',
    en_US: 'Description',
    tr_TR: 'Açıklama',
    ar_SA: 'الوصف',
    id_ID: 'Deskripsi',
    pt_BR: 'Descrição',
    ru_RU: 'Описание',
    uz_UZ: 'Ma\'lumot',
    fa_IR: 'توضیحات',
    ur_PK: 'تفصیلات'
  },
  色情: {
    zh_CN: '色情',
    en_US: 'pornography',
    ar_SA: 'التخييم',
    tr_TR: 'Pornografi',
    pt_BR: 'Pornografia',
    id_ID: 'Pornografi',
    ru_RU: 'Порнография',
    uz_UZ: 'Pornografiya',
    fa_IR: 'پرونوگرافی',
    ur_PK: 'پرونوگرافی'
  },
  宗教: {
    zh_CN: '宗教',
    en_US: 'Religion',
    ar_SA: 'الدين',
    tr_TR: 'Din',
    pt_BR: 'Religião',
    id_ID: 'Agama',
    ru_RU: 'Религия',
    uz_UZ: 'Din',
    fa_IR: 'دین',
    ur_PK: 'دین'
  },
  政治: {
    zh_CN: '政治',
    en_US: 'Politics',
    ar_SA: 'السياسة',
    tr_TR: 'Siyaset',
    pt_BR: 'Política',
    id_ID: 'Politik',
    ru_RU: 'Политика',
    uz_UZ: 'Siyosat',
    fa_IR: 'سیاسی',
    ur_PK: 'سیاسی'
  },
  其他: {
    zh_CN: '其他',
    en_US: 'Other',
    ar_SA: 'أخرى',
    tr_TR: 'Diger',
    pt_BR: 'Outro',
    id_ID: 'Lain-lain',
    ru_RU: 'Другое',
    uz_UZ: 'Boshqa',
    fa_IR: 'سایر',
    ur_PK: 'سایر'
  },
  descriptionDetail: {
    zh_CN: '请详细描述具体情况',
    en_US: 'Please provide more details',
    ar_SA: 'يرجى توفر تفاصيل أكثر',
    tr_TR: 'Lütfen daha ayrıntılı bilgi verin',
    pt_BR: 'Por favor, forneça mais detalhes',
    id_ID: 'Silakan berikan informasi lebih lanjut',
    ru_RU: 'Пожалуйста, укажите дополнительную информацию',
    uz_UZ: 'Qizilmalarni to\'liq tasdiqlang',
    fa_IR: 'لطفا اطلاعات بیشتری را به اشتراک بگذارید',
    ur_PK: 'کمزور کرنے کے لئے مزید تفصیلات اپ کیا گیا ہے'
  },
  提交: {
    zh_CN: '提交',
    en_US: 'Submit',
    ar_SA: 'تسجيل',
    tr_TR: 'Gönder',
    pt_BR: 'Enviar',
    id_ID: 'Mengirim',
    ru_RU: 'Отправить',
    uz_UZ: 'Jo\'natish',
    fa_IR: 'ثبت',
    ur_PK: 'تسلیم کریں'
  },
  请选择举报类型: {
    zh_CN: '请选择举报类型',
    en_US: 'Please select report type',
    ar_SA: 'يرجى تحديد نوع التبليغ',
    tr_TR: 'Lütfen rapor türünü seçin',
    pt_BR: 'Por favor, selecione o tipo de denúncia',
    id_ID: 'Silakan pilih jenis laporan',
    ru_RU: 'Пожалуйста, выберите тип жалобы',
    uz_UZ: 'Iltimos, shikoyat turini tanlang',
    fa_IR: 'لطفا نوع گزارش را انتخاب کنید',
    ur_PK: 'لطفا گزارش کی ترتیب را انتخاب کریں'
  },
  操作成功: {
    zh_CN: '操作成功',
    en_US: 'Operation successful',
    ar_SA: 'تمت العملية',
    tr_TR: 'İşlem başarılı',
    pt_BR: 'Operação bem sucedida',
    id_ID: 'Operasi berhasil',
    ru_RU: 'Операция выполнена',
    uz_UZ: 'Operatsiya muvaffaqiyatli amalga oshdi',
    fa_IR: 'عملیات موفقیت آمیز شد',
    ur_PK: 'عملیات کامیاب انجام شد'
  },
  财富: {
    zh_CN: '财富',
    en_US: 'Wealth',
    ar_SA: 'الأثر',
    tr_TR: 'Günlük Gelir',
    pt_BR: 'Renda',
    id_ID: 'Keuangan',
    ru_RU: 'Денежные средства',
    uz_UZ: 'Maliyet',
    fa_IR: 'اقتصاد',
    ur_PK: 'اقتصادیات'
  },
  魅力: {
    zh_CN: '魅力',
    en_US: 'Charm',
    ar_SA: 'الجمال',
    tr_TR: 'Güzellik',
    pt_BR: 'Beleza',
    id_ID: 'Keindahan',
    ru_RU: 'Внешность',
    uz_UZ: 'Ko\'rsatish',
    fa_IR: 'جمال',
    ur_PK: 'جمال'
  },
  '只有<b>{{n}}</b>%的用户达到了这个级别': {
    zh_CN: '只有 <b>{{n}}</b>% 的用户达到了这个级别',
    en_US: 'Only <b>{{n}}</b>% of users reached this level',
    ar_SA: 'فقط <b>{{n}}</b>٪ من المستخدمين اختيار هذا النمط',
    tr_TR: 'Sadece <b>{{n}}</b>% kullanıcı bu seviyeye ulaştı',
    pt_BR: 'Apenas <b>{{n}}</b>% dos usuários alcançaram este nível',
    id_ID: 'Hanya <b>{{n}}</b>% pengguna yang mencapai tahap ini',
    ru_RU: 'Только <b>{{n}}</b>% пользователей достиг этого уровня',
    uz_UZ: 'Faqat <b>{{n}}</b>% foydalanuvchilar bu yutuqlarga qabul qilgan',
    fa_IR: 'فقط <b>{{n}}</b>٪ کاربران این مقام را انجام دادند',
    ur_PK: 'فقط <b>{{n}}</b>٪ کاربر این مقام را انجام دادی'
  },
  当前级别权限: {
    zh_CN: '当前级别权限',
    en_US: 'Current Level Permissions',
    ar_SA: 'صلاحيات نمط حالي',
    tr_TR: 'Mevcut Seviye İzinleri',
    pt_BR: 'Permissões do Nível Atual',
    id_ID: 'Izin Sekarang',
    ru_RU: 'Разрешения текущего уровня',
    uz_UZ: 'O‘zgaruvchilarni baholash',
    fa_IR: 'مجوزات مقام فعلی',
    ur_PK: 'جاری مقام کی حصائیات'
  },
  所有级别奖牌: {
    zh_CN: '所有级别奖牌',
    en_US: 'All Level Awards',
    ar_SA: 'جوائز الكل',
    tr_TR: 'Tüm Seviye Ödüller',
    pt_BR: 'Prêmios de Todos os Níveis',
    id_ID: 'Hadiah Semua Tingkat',
    ru_RU: 'Все награды уровней',
    uz_UZ: 'Barcha yutuqlar',
    fa_IR: 'جوایز هر مقام',
    ur_PK: 'جوائز کل مقام'
  },
  如何升级: {
    zh_CN: '如何升级',
    en_US: 'How to Upgrade',
    ar_SA: 'كيفية الترقية',
    tr_TR: 'Nasıl Yükseltirilir',
    pt_BR: 'Como Atualizar',
    id_ID: 'Cara Mengupgrade',
    ru_RU: 'Как повысить уровень',
    uz_UZ: 'Yutuqlarni tayyorlash',
    fa_IR: 'نحوه ارتقا',
    ur_PK: 'نحوه ترقیع'
  },
  送礼物: {
    zh_CN: '送礼物',
    en_US: 'Send Gift',
    ar_SA: 'إرسال جوائز',
    tr_TR: 'Hediye Çek',
    pt_BR: 'Enviar Presente',
    id_ID: 'Mengirim Hadiah',
    ru_RU: 'Подарить подарок',
    uz_UZ: 'Yetkazib berish',
    fa_IR: 'پیشنهاد دادن',
    ur_PK: 'پیشنهاد دیں'
  },
  收礼物: {
    zh_CN: '收礼物',
    en_US: 'Receive Gift',
    ar_SA: 'استلام جوائز',
    tr_TR: 'Hediye Al',
    pt_BR: 'Receber Presente',
    id_ID: 'Menerima Hadiah',
    ru_RU: 'Получить подарок',
    uz_UZ: 'Yetkazib berish',
    fa_IR: 'پیشنهاد رسیدگی',
    ur_PK: 'پیشنهاد رسیدگی'
  },
  '普通礼物100金币={{n}}Exp': {
    zh_CN: '普通礼物100金币={{n}}Exp',
    en_US: 'Common Gift 100 Gold Coins={{n}}Exp',
    ar_SA: 'جوائز عادية 100 طلبة نقدية={{n}}Exp',
    tr_TR: 'Genel Hediye 100 Gümüş Mübarek={{n}}Exp',
    pt_BR: 'Presente Comum 100 Moedas de Ouro={{n}}Exp',
    id_ID: 'Hadiah Umum 100 Koin Emas={{n}}Exp',
    ru_RU: 'Обычный подарок 100 золотых монет={{n}}Exp',
    uz_UZ: "Umumiy yetkazib 100 so'mlik kupon={{n}}Exp",
    fa_IR: 'پیشنهاد عادی 100 گلدان={{n}}Exp',
    ur_PK: 'عادی پیشنهاد 100 گلدن کیلئے={{n}}Exp'
  },
  '幸运礼物100金币={{n}}Exp': {
    zh_CN: '幸运礼物100金币={{n}}Exp',
    en_US: 'Lucky Gift 100 Gold Coins={{n}}Exp',
    ar_SA: 'جوائز مثلثة 100 طلبة نقدية={{n}}Exp',
    tr_TR: 'Çok Zararlı Hediye 100 Gümüş Mübarek={{n}}Exp',
    pt_BR: 'Presente Sorte 100 Moedas de Ouro={{n}}Exp',
    id_ID: 'Hadiah Lucky 100 Koin Emas={{n}}Exp',
    ru_RU: 'Выигрышный подарок 100 золотых монет={{n}}Exp',
    uz_UZ: "Mavjud yetkazib 100 so'mlik kupon={{n}}Exp",
    fa_IR: 'پیشنهاد موفق 100 گلدان={{n}}Exp',
    ur_PK: 'موفق پیشنهاد 100 گلدن کیلئے={{n}}Exp'
  },
  公会大厅: {
    zh_CN: '公会大厅',
    en_US: 'Agency Hall',
    ar_SA: 'المنزل الأساسي',
    tr_TR: 'Kuruluş Salonu',    
    pt_BR: 'Salão da Casa de Guerra',
    id_ID: 'Ruang Keluarga',
    ru_RU: 'Гостиница Клуба',
    uz_UZ: 'Kurilish xonasi',
    fa_IR: 'باغ کارگری',
    ur_PK: 'کارگری کیلئے'
  },
  公会主页: {
    zh_CN: '公会主页',
    en_US: 'Agency Home',
    ar_SA: 'الصفحة الرئيسية للوكالة',
    tr_TR: 'Ajans Ana Sayfası',
    pt_BR: 'Página Inicial da Agência',
    id_ID: 'Beranda Agensi',
    ru_RU: 'Главная страница агентства',
    uz_UZ: 'Agentlik Bosh Sahifasi',
    fa_IR: 'صفحه اصلی آژانس',
    ur_PK: 'ایجنسی ہوم',
  },
  创建: {
    zh_CN: '创建',
    en_US: 'Create',
    ar_SA: 'إنشاء',
    tr_TR: 'Oluştur',
    pt_BR: 'Criar',
    id_ID: 'Membuat',
    ru_RU: 'Создать',
    uz_UZ: 'Yaratish',
    fa_IR: 'ساخت',
    ur_PK: 'ساخت'
  },
  输入公会ID: {
    zh_CN: '输入公会ID',
    en_US: 'Enter Agency ID',
    ar_SA: 'أدخل رقم الأساسي',
    tr_TR: 'Kuruluş ID\'sini Girin',
    pt_BR: 'Digite o ID da Casa de Guerra',
    id_ID: 'Masukkan ID Keluarga',
    ru_RU: 'Введите ID Клуба',
    uz_UZ: 'Kurilish ID ni kiriting',
    fa_IR: 'ایدی کارگری را وارد کنید',
    ur_PK: 'کارگری کیلئے کا دھرنے کریں'
  },
  公会ID: {
    zh_CN: '公会ID',
    en_US: 'Agency ID',
    ar_SA: 'رقم الأساسي',
    tr_TR: 'Kuruluş ID\'si',
    pt_BR: 'ID da Casa de Guerra',
    id_ID: 'ID Keluarga',
    ru_RU: 'ID Клуба',
    uz_UZ: 'Kurilish ID',
    fa_IR: 'ایدی کارگری',
    ur_PK: 'کارگری کیلئے کا دھرنے'
  },
  创建公会: {
    zh_CN: '创建公会',
    en_US: 'Create Agency',
    ar_SA: 'إنشاء الأساسي',
    tr_TR: 'Kuruluş Oluştur',
    pt_BR: 'Criar Casa de Guerra',
    id_ID: 'Membuat Keluarga',
    ru_RU: 'Создать Клуб',
    uz_UZ: 'Kurilish yaratish',
    fa_IR: 'ساخت کارگری',
    ur_PK: 'کارگری ساخت'
  },
  封面: {
    zh_CN: '封面',
    en_US: 'Cover',
    ar_SA: 'غطاء',
    tr_TR: 'Kapak',
    pt_BR: 'Capa',
    id_ID: 'Kap',
    ru_RU: 'Обложка',
    uz_UZ: 'Kap',
    fa_IR: 'کاپ',
    ur_PK: 'کاپ'
  },
  请选择小于3M的图片: {
    zh_CN: '请选择小于3M的图片',
    en_US: 'Please select a picture less than 3M',
    ar_SA: 'الرجاء اختيار صورة أقل من 3 ميجا',
    tr_TR: 'Lütfen 3MB\'tan az bir resim seçin',
    pt_BR: 'Por favor, selecione uma imagem com menos de 3MB',
    id_ID: 'Silakan pilih gambar kurang dari 3MB',
    ru_RU: 'Пожалуйста, выберите изображение меньше 3МБ',
    uz_UZ: 'Iltimos, rasm 3MB dan kam bo\'ylab kimga tasdiqlang',
    fa_IR: 'لطفا یک تصویر کمتر از 3 مگابایت را انتخاب کنید',
    ur_PK: 'لطفا یک تصویر کمتر از 3 مگابایت را انتخاب کریں'
  },
  上级外管或BD: {
    zh_CN: '上级外管或BD',
    en_US: 'Upper Management or BD',
    ar_SA: 'الإدارة العليا أو التنفيذية',
    tr_TR: 'Üst Yönetim veya BD',
    pt_BR: 'Gestão Superior ou BD',
    id_ID: 'Manajemen Atas atau BD',
    ru_RU: 'Верховный управляющий или БД',
    uz_UZ: 'Maxsus huquqiy huquqda yoki BD',
    fa_IR: 'سرپرستی بالاتر یا BD',
    ur_PK: 'بالاترین مدیریت یا BD'
  },
  输入ID: {
    zh_CN: '输入ID',
    en_US: 'Enter ID',
    ar_SA: 'أدخل معرف',
    tr_TR: 'ID Girin',
    pt_BR: 'Digite o ID',
    id_ID: 'Masukkan ID',
    ru_RU: 'Введите ID',
    uz_UZ: 'IDni kiriting',
    fa_IR: 'شناسه را وارد کنید',
    ur_PK: 'ID درج کریں',
  },
  所属国家或地区: {
    zh_CN: '所属国家或地区',
    en_US: 'Country or region of origin',
    ar_SA: 'بلد أو منطقة المنشأ',
    tr_TR: 'Ülke veya Bölge',
    pt_BR: 'País ou Região',
    id_ID: 'Negara atau Wilayah',
    ru_RU: 'Страна или регион',
    uz_UZ: 'Mamlakat yoki tuman',
    fa_IR: 'کشور یا منطقه',
    ur_PK: 'پالتو یا منطقہ'
  },
  'Tips: 如对上级外管或 BD 不了解，可联系官方 WhatsApp:{{n}}': {
    zh_CN: 'Tips: 如对上级外管或 BD 不了解，可联系官方 WhatsApp:{{n}}',
    en_US: 'Tips: If you are not familiar with the upper management or BD, please contact the official WhatsApp:{{n}}',
    ar_SA: 'نصائح: إذا لم تعلم الإدارة العليا أو التنفيذية، يرجى الاتصال بالمركز الرسمي الفني الخاص بالواتساب:{{n}}',
    tr_TR: 'İpucu: Üst yönetim veya BD hakkında bilgi almak istemiyorsanız, lütfen resmi WhatsApp\'ta iletişime geçin:{{n}}',
    pt_BR: 'Dicas: Se você não estiver familiarizado com a gestão superior ou BD, por favor, contate o WhatsApp oficial:{{n}}',
    id_ID: 'Tips: Jika Anda tidak familiar dengan manajemen atas atau BD, silakan hubungi WhatsApp resmi:{{n}}',
    ru_RU: 'Подсказка: Если вы не знаете верховного управляющего или БД, свяжитесь с официальным WhatsApp:{{n}}',
    uz_UZ: 'Qo\'shimcha ma\'lumot: Agar sizning maxsus huquqiy huquqda yoki BD haqida ma\'lumot bermang o\'zroq bo\'lmasligi sizga ofisdagi WhatsApp orqali bog\'laning:{{n}}',
    fa_IR: 'نکات: زمانی که با سرپرستی بالاتر یا BD آشنایی ندارید، لطفا از این راه به رسانه فنی مرکزی اینترنتی خود ارتباط بگیرید:{{n}}',
    ur_PK: 'نکات: زمانی کے سرپرستی بالاتر یا BD کیا ہے، اپنا فنی مرکزی واتساب کی رسائی رکھنے کے لئے تماس بگیرید:{{n}}'
  },
  请输入外管或BD的ID: {
    zh_CN: '请输入外管或BD的ID',
    en_US: 'Please enter the ID of the upper management or BD',
    ar_SA: 'الرجاء إدخال رقم الإدارة العليا أو التنفيذية',
    tr_TR: 'Üst yönetim veya BD ID\'sini girin',
    pt_BR: 'Por favor, insira o ID da gestão superior ou BD',
    id_ID: 'Silakan masukkan ID manajemen atas atau BD',
    ru_RU: 'Пожалуйста, введите ID верховного управляющего или БД',
    uz_UZ: 'Iltimos, maxsus huquqiy huquqda yoki BD ID ni kiriting',
    fa_IR: 'لطفا ایدی سرپرستی بالاتر یا BD را وارد کنید',
    ur_PK: 'لطفا کارگری کیلئے یا BD کا دھرنے کریں'
  },
  选择地区: {
    zh_CN: '选择地区',
    en_US: 'Select Region',
    ar_SA: 'اختر منطقة',
    tr_TR: 'Bölge Seç',
    pt_BR: 'Selecione a Região',
    id_ID: 'Pilih Wilayah',
    ru_RU: 'Выберите регион',
    uz_UZ: 'Tilni tanlang',
    fa_IR: 'انتخاب منطقه',
    ur_PK: 'منطقہ منتخب کریں'
  },
  取消: {
    zh_CN: '取消',
    en_US: 'Cancel',
    ar_SA: 'يلغي',
    tr_TR: 'İptal',
    pt_BR: 'Cancelar',
    id_ID: 'Batal',
    ru_RU: 'Отмена',
    uz_UZ: 'Bekor qilish',
    fa_IR: 'لغو',
    ur_PK: 'کنسل کریں'
  },
  确定: {
    zh_CN: '确定',
    en_US: 'Confirm',
    ar_SA: 'تأكيد',
    tr_TR: 'Onayla',
    pt_BR: 'Confirmar',
    id_ID: 'Konfirmasi',
    ru_RU: 'Подтвердить',
    uz_UZ: 'Tasdiqlash',
    fa_IR: 'تایید',
    ur_PK: 'تصدیق کریں'
  },
  请输入公会名称: {
    zh_CN: '请输入公会名称',
    en_US: 'Please enter the name of the Agency',
    ar_SA: 'الرجاء إدخال اسم الأساسي',
    tr_TR: 'Kuruluşun adını girin',
    pt_BR: 'Por favor, insira o nome da Casa de Guerra',
    id_ID: 'Silakan masukkan nama Keluarga',
    ru_RU: 'Пожалуйста, введите название Клуба',
    uz_UZ: 'Iltimos, kurilish nomini kiriting',
    fa_IR: 'لطفا نام کارگری را وارد کنید',
    ur_PK: 'لطفا کارگری کا نام را وارد کریں'
  },
  请上传公会封面: {
    zh_CN: '请上传公会封面',
    en_US: 'Please upload the Agency cover',
    ar_SA: 'الرجاء رفع غطاء الأساسي',
    tr_TR: 'Kuruluş kapak fotoğrafını yükleyin',
    pt_BR: 'Por favor, envie a capa da Casa de Guerra',
    id_ID: 'Silakan unggah kartu Keluarga',
    ru_RU: 'Пожалуйста, загрузите обложку Клуба',
    uz_UZ: 'Iltimos, kurilish kapağı yuklang',
    fa_IR: 'لطفا کاپ را آپلود کنید',
    ur_PK: 'لطفا کارگری کا کاپ را آپلود کریں'
  },
  请选择外管或BD: {
    zh_CN: '请选择外管或BD',
    en_US: 'Please select the upper management or BD',
    ar_SA: 'الرجاء اختيار الإدارة العليا أو التنفيذية',
    tr_TR: 'Üst yönetim veya BD\'yi seçin',
    pt_BR: 'Por favor, selecione a gestão superior ou BD',
    id_ID: 'Silakan pilih manajemen atas atau BD',
    ru_RU: 'Пожалуйста, выберите верховного управляющего или БД',
    uz_UZ: 'Iltimos, maxsus huquqiy huquqda yoki BDni tanlang',
    fa_IR: 'لطفا سرپرستی بالاتر یا BD را انتخاب کنید',
    ur_PK: 'لطفا بالاترین مدیریت یا BD را منتخب کریں'
  },
  标签: {
    zh_CN: '标签',
    en_US: 'Label',
    ar_SA: 'تسمية',
    tr_TR: 'Etiket',
    pt_BR: 'Rótulo',
    id_ID: 'Label',
    ru_RU: 'Тег',
    uz_UZ: 'Etiket',
    fa_IR: 'برچسب',
    ur_PK: 'تسمیم'
  },
  勋章: {
    zh_CN: '勋章',
    en_US: 'Medal',
    ar_SA: 'جوزيف',
    tr_TR: 'Medal',
    pt_BR: 'Medalha',
    id_ID: 'Medali',
    ru_RU: 'Медаль',
    uz_UZ: 'Jamoat',
    fa_IR: 'مدال',
    ur_PK: 'مدال'
  },
  已申请: {
    zh_CN: '已申请',
    en_US: 'Applied',
    ar_SA: 'تم التقدم',
    tr_TR: 'Başvuruldu',
    pt_BR: 'Aplicado',
    id_ID: 'Diterima',
    ru_RU: 'Заявка принята',
    uz_UZ: 'Taqdim qilingan',
    fa_IR: 'تقدیم شده',
    ur_PK: 'تقدیم شدہ'
  },
  我的公会:  {
    zh_CN: '我的公会',
    en_US: 'My Agency',
    ar_SA: 'الأساسي الخاص بي',
    tr_TR: 'Benim Kuruluşum',
    pt_BR: 'Minha Casa de Guerra',
    id_ID: 'Keluarga Saya',
    ru_RU: 'Моя Клуба',
    uz_UZ: 'Mening kurilishim',
    fa_IR: 'کارگری من',
    ur_PK: 'من کارگری'
  },
  确认申请加入该公会: {
    zh_CN: '确认申请加入该公会?',
    en_US: 'Confirm applying to join this Agency?',
    ar_SA: 'تأكيد التقدم للانضمام إلى هذه الأساسية؟',
    tr_TR: 'Bu Kuruluşa katılmak için başvuruyu onaylayın mı?',
    pt_BR: 'Confirma se inscrever neste Agência?',
    id_ID: 'Konfirmasi mendaftar untuk bergabung dengan Keluarga ini?',
    ru_RU: 'Подтвердите заявку на присоединение к этому Клубу?',
    uz_UZ: 'Taqdim qilishni bu kurilishga ajoyib ketishni tasdiqlang?',
    fa_IR: 'تایید این کارگری را به عنوان یک کارگری جدید اعلام کنید؟',
    ur_PK: 'کارگری کے لئے ان کی آپ کی آپ کی تقدیم کیا گیا ہے؟'
  },
  无法重新申请加入公会: {
    zh_CN: '无法重新申请加入公会',
    en_US: 'Unable to reapply to join this Agency',
    ar_SA: 'لا يمكن إعادة التقدم للانضمام إلى هذه الأساسية',
    tr_TR: 'Bu Kuruluşa katılmak için başvuruyu tekrar yapamazsın',
    pt_BR: 'Incapaz de se inscrever neste Agência novamente',
    id_ID: 'Tidak dapat mengulangi pendaftaran untuk bergabung dengan Keluarga ini',
    ru_RU: 'Невозможно повторно подать заявку на присоединение к этому Клубу',
    uz_UZ: 'Bu kurilishga ajoyib ketishni qayta tasdiqlash mumkin emas',
    fa_IR: 'این کارگری را به عنوان یک کارگری جدید اعلام نمی‌کنم',
    ur_PK: 'کارگری کے لئے ان کی آپ کی آپ کی تقدیم کیا گیا ہے'
  },
  提交成功: {
    zh_CN: '提交成功',
    en_US: 'Submitted successfully',
    ar_SA: 'تم التقدم بنجاح',
    tr_TR: 'Başvuru başarıyla gönderildi',
    pt_BR: 'Submetido com sucesso',
    id_ID: 'Berhasil mengajukan',
    ru_RU: 'Заявка успешно подана',
    uz_UZ: 'Taqdim qilindi',
    fa_IR: 'تقدیم شد',
    ur_PK: 'تقدیم کر دیا گیا'
  },
  '等级越高，获得等级勋章越豪华': {
    zh_CN: '等级越高，获得等级勋章越豪华',
    en_US: 'The higher the level, the more expensive the level medal',
    ar_SA: 'على حد الأسعار، يكفي أكبر جوزيف للمستوى',
    tr_TR: 'Daha yüksek seviye, seviye medali daha pahalı olur',
    pt_BR: 'Quanto mai alto o nível, mais cara é a medalha do nível',
    id_ID: 'Semakin tinggi level, semakin mahal yang didapatkan',
    ru_RU: 'Чем выше уровень, тем дороже уровневая медаль',
    uz_UZ: 'Seviyaga tegishli bo\'lgan jamoat narsa qiymati kamaytiriladi',
    fa_IR: 'بالاترین مدال هم بیشتر قیمت دارد',
    ur_PK: 'بالاترین مدال میں قیمت بالاتر ہوں'
  },
  常用功能: {
    zh_CN: '常用功能',
    en_US: 'Common Functions',
    ar_SA: 'الوظائف الشائعة',
    tr_TR: 'Genel İşlevler',
    pt_BR: 'Funções Comuns',
    id_ID: 'Fungsi Umum',
    ru_RU: 'Общие функции',
    uz_UZ: 'Umumiy funksiyalar',
    fa_IR: 'وظایف پرکاربرد',
    ur_PK: 'میں کاربردی معاملات'
  },
  数据中心: {
    zh_CN: '数据中心',
    en_US: 'Data Center',
    ar_SA: 'مركز البيانات', 
    tr_TR: 'Veri Merkezi',
    pt_BR: 'Centro de Dados',
    id_ID: 'Pusat Data',
    ru_RU: 'Центральный центр',
    uz_UZ: 'Ma\'ruza',
    fa_IR: 'مرکز داده',
    ur_PK: 'دیتا مرکز'
  },
  成员: {
    zh_CN: '成员',
    en_US: 'Members',
    ar_SA: 'أعضاء',
    tr_TR: 'Üyeler',
    pt_BR: 'Membros',
    id_ID: 'Anggota',
    ru_RU: 'Участники',
    uz_UZ: 'Amal',
    fa_IR: 'اعضاء',
    ur_PK: 'عضویت'
  },
  编辑资料: {
    zh_CN: '编辑资料',
    en_US: 'Edit Profile',
    ar_SA: 'تحرير الملف الشخصي',
    tr_TR: 'Profili Düzenle',
    pt_BR: 'Editar Perfil',
    id_ID: 'Edit Profil',
    ru_RU: 'Редактировать профиль',
    uz_UZ: 'Profilni tahrirlash',
    fa_IR: 'پروفایل ویرایش',
    ur_PK: 'پروفایل ویرایش کریں'
  },
  公会名称: {
    zh_CN: '公会名称',
    en_US: 'Agency Name',
    ar_SA: 'اسم الأساسية',
    tr_TR: 'Kuruluş Adı',
    pt_BR: 'Nome da Casa de Guerra',
    id_ID: 'Nama Keluarga',
    ru_RU: 'Название Клуба',
    uz_UZ: 'Kurilish nomi',
    fa_IR: 'نام کارگری',
    ur_PK: 'نام کارگری'
  },
  公会宣言: {
    zh_CN: '公会宣言',
    en_US: 'Announcement',
    ar_SA: 'إعلان',
    tr_TR: 'Duyuru',
    pt_BR: 'Anúncio',
    id_ID: 'Pengumuman',
    ru_RU: 'Объявление',
    uz_UZ: 'E\'lon',
    fa_IR: 'آگاهی',
    ur_PK: 'آگاہ'
  },
  更新成功: {
    zh_CN: '更新成功',
    en_US: 'Updated successfully',
    ar_SA: 'تم تحديثه بنجاح',
    tr_TR: 'Güncelleme başarılı',
    pt_BR: 'Atualizado com sucesso',
    id_ID: 'Berhasil diperbarui',
    ru_RU: 'Обновление прошло успешно',
    uz_UZ: 'Yangilash muvaffaqiyatli',
    fa_IR: 'به روز رسانی شد',
    ur_PK: 'به روز رسانی کر دیا گیا'
  },
  成员管理: {
    zh_CN: '成员管理',
    en_US: 'Member Management',
    ar_SA: 'إدارة الأعضاء',
    tr_TR: 'Üye Yönetimi',
    pt_BR: 'Gestão de Membros',
    id_ID: 'Manajemen Anggota',
    ru_RU: 'Управление участниками',
    uz_UZ: 'Amalni boshqarish',
    fa_IR: 'مدیریت اعضاء',
    ur_PK: 'عضویت کی مدیریت'
  },
  加入公会申请: {
    zh_CN: '加入公会申请',
    en_US: 'Apply to Join Agency',
    ar_SA: 'التقدم بطلب للانضمام إلى الوكالة',
    tr_TR: 'Ajansa Katılmak İçin Başvurun',
    pt_BR: 'Solicitar Adesão à Agência',
    id_ID: 'Mendaftar Bergabung dengan Keluarga',
    ru_RU: 'Заявка на присоединение к Клубу',
    uz_UZ: 'Kurilishga ajoyib ketishni tasdiqlash',
    fa_IR: 'کارگری را به عنوان یک کارگری جدید اعلام کنید',
    ur_PK: 'کارگری کے لئے ان کی آپ کی آپ کی تقدیم کیا گیا ہے'
  },
  成员列表: {
    zh_CN: '成员列表',
    en_US: 'Member List',
    ar_SA: 'قائمة الأعضاء',
    tr_TR: 'Üye Listesi',
    pt_BR: 'Lista de Membros',
    id_ID: 'Daftar Anggota',
    ru_RU: 'Список участников',
    uz_UZ: 'Amal ro\'yxati',
    fa_IR: 'لیست اعضاء',
    ur_PK: 'لیست عضویت',
  },
  加入申请: {
    zh_CN: '加入申请',
    en_US: 'Apply to Join',
    ar_SA: 'التقدم بطلب الانضمام',
    tr_TR: 'Katılmak İçin Başvurun',
    pt_BR: 'Solicitar Adesão',
    id_ID: 'Mendaftar Bergabung',
    ru_RU: 'Заявка на присоединение',
    uz_UZ: 'Kurilishga ajoyib ketish',
    fa_IR: 'درخواست عضویت',
    ur_PK: 'تقدیم کرنے کے لئے'
  },
  申请时间: {
    zh_CN: '申请时间',
    en_US: 'Apply Time',
    ar_SA: 'وقت التقدم',
    tr_TR: 'Başvuru Zamanı',
    pt_BR: 'Tempo de Solicitação',
    id_ID: 'Waktu Pendaftaran',
    ru_RU: 'Время заявки',
    uz_UZ: 'Taqdim vaqti',
    fa_IR: 'زمان درخواست',
    ur_PK: 'تقدیم زمان'
  },
  '感谢举报,我们将在24小时内处理': {
    zh_CN: '感谢举报,我们将在24小时内处理',
    en_US: 'Thank you for reporting, we will handle it within 24 hours',
    ar_SA: 'شكرا للإبلاغ، سوف نقوم بالتحديد في 24 ساعة',
    tr_TR: 'Rapor vermek için teşekkür ederiz, 24 saat içerisinde işleme alacağız',
    pt_BR: 'Obrigado pela denúncia, entraremos em contato em até 24 horas',
    id_ID: 'Terima kasih atas laporan, kami akan segera menangani dalam 24 jam',
    ru_RU: 'Спасибо за жалобу, мы обработаем в течение 24 часов',
    uz_UZ: 'Rapor qoldirish uchun rahmat, 24 soatda amalga oshirishga harakat qilamiz',
    fa_IR: 'شكری از گزارش شما، در 24 ساعت انجام خواهیم داد',
    ur_PK: 'گزارش کی تشکر، ۲۴ ساعت میں مدیریت کیا گیا ہے'
  },
  暂无数据: {
    zh_CN: '暂无数据',
    en_US: 'No Data',
    ar_SA: 'لا توجد بيانات',
    tr_TR: 'Veri Yok',
    pt_BR: 'Sem Dados',
    id_ID: 'Tidak Ada Data',
    ru_RU: 'Нет данных',
    uz_UZ: 'Ma\'lumot yo\'q',
    fa_IR: 'بدون داده',
    ur_PK: 'کوئی ڈیٹا نہیں'
  },
  确认同意该用户加入公会: {
    zh_CN: '确认同意该用户加入公会?',
    en_US: 'Confirm that the user agrees to join the agency?',
    ar_SA: 'هل يوجد موافقة من المستخدم للانضمام إلى الوكالة؟',
    tr_TR: 'Kullanıcıyı kuruluşa katılmak için kabul etmeyi onaylıyor musunuz?',
    pt_BR: 'O usuário concorda em se juntar à agência?',
    id_ID: 'Apakah pengguna menyetujui bergabung dengan keluarga?',
    ru_RU: 'Подтвердите, что пользователь согласен с участием в Клубе?',
    uz_UZ: 'Foydalanuvchi ro\'yxatdan o\'tganini kurilishga ruxsat berishni tasdiqlang?',
    fa_IR: 'کاربر انتقادات خود را دارد؟',
    ur_PK: 'کاربر انتقادات کے لئے کیا گیا ہے؟'
  },
  确认拒绝该用户加入公会: {
    zh_CN: '确认拒绝该用户加入公会?',
    en_US: 'Confirm that the user disagrees to join the agency?',
    ar_SA: 'هل يوجد موافقة من المستخدم للانضمام إلى الوكالة؟',
    tr_TR: 'Kullanıcıyı kuruluşa katılmak için kabul etmeyi reddetmeyi onaylıyor musunuz?',
    pt_BR: 'O usuário concorda em não se juntar à agência?',
    id_ID: 'Apakah pengguna tidak setuju bergabung dengan keluarga?',
    ru_RU: 'Подтвердите, что пользователь не согласен с участием в Клубе?',
    uz_UZ: 'Foydalanuvchi ro\'yxatdan o\'tganini kurilishga ruxsat berishni qaytarishni tasdiqlang?',
    fa_IR: 'کاربر انتقادات خود را دارد؟',
    ur_PK: 'کاربر انتقادات کے لئے کیا گیا ہے؟'
  },
  加入时间: {
    zh_CN: '加入时间',
    en_US: 'Join Time',
    ar_SA: 'وقت الانضمام',
    tr_TR: 'Katılma Zamanı',
    pt_BR: 'Tempo de Entrada',
    id_ID: 'Waktu Bergabung',
    ru_RU: 'Время вступления',
    uz_UZ: 'Kurish vaqti',
    fa_IR: 'زمان ورود',
    ur_PK: 'تلاش کی زمان'
  },
  更多操作: {
    zh_CN: '更多操作',
    en_US: 'More Operations',
    ar_SA: 'العمليات الأكثر',
    tr_TR: 'Daha Fazla İşlem',
    pt_BR: 'Mais Operações',
    id_ID: 'Operasi Lainnya',
    ru_RU: 'Дополнительные операции',
    uz_UZ: 'Boshqa amal',
    fa_IR: 'ادامه ترمین',
    ur_PK: 'اقدامات بیشتر'
  },
  设为管理员: {
    zh_CN: '设为管理员',
    en_US: 'Set as Admin',  
    ar_SA: 'تعيين كمشرف',
    tr_TR: 'Yönetici Olarak Ayarla',
    pt_BR: 'Definir como Administrador',
    id_ID: 'Atur sebagai Admin',
    ru_RU: 'Назначить администратором',
    uz_UZ: 'Admin ga tayyorlash',
    fa_IR: 'تعیین به عنوان مدیر',
    ur_PK: 'مدیر کی تعیین کریں'
  },
  取消管理员: {
    zh_CN: '取消管理员',
    en_US: 'Remove Admin',
    ar_SA: 'إزالة من الوكالة',
    tr_TR: 'Yöneticiyi Kaldır',
    pt_BR: 'Remover Administrador',
    id_ID: 'Hapus Admin',
    ru_RU: 'Убрать из администраторов',
    uz_UZ: 'Admin o\'chirish',
    fa_IR: 'حذف مدیر',
    ur_PK: 'مدیر حذف کریں'
  },
  移出公会: {
    zh_CN: '移出公会',
    en_US: 'Remove from Agency',
    ar_SA: 'إزالة من الوكالة',
    tr_TR: 'Kuruluştan Çıkar',
    pt_BR: 'Remover da Agência',
    id_ID: 'Keluarga Diluar',
    ru_RU: 'Удалить из Клуба',
    uz_UZ: 'Kurilgandan olib tashlash',
    fa_IR: 'از کارگری حذف کردن',
    ur_PK: 'کارگری میں حذف کریں'
  },
  确认将该用户移出公会: {
    zh_CN: '确认将该用户移出公会?',
    en_US: 'Confirm that the user will be removed from the agency?',
    ar_SA: 'هل تريد حذف المستخدم من الوكالة؟',
    tr_TR: 'Kullanıcıyı kuruluştan çıkaracaksınız mı?',
    pt_BR: 'O usuário será removido da agência?',
    id_ID: 'Apakah pengguna akan dihapus dari keluarga?',
    ru_RU: 'Подтвердите, что пользователь будет удален из Клуба?',
    uz_UZ: 'Foydalanuvchini kurilgandan olib tashlashni tasdiqlang?',
    fa_IR: 'کاربر حذف شود؟',
    ur_PK: 'کاربر کی حذف کرنے کے لئے کیا گیا ہے؟'
  },
  确认解除该用户的公会管理员: {
    zh_CN: '确认解除该用户的公会管理员?',
    en_US: 'Confirm that the user will be removed as an agency admin?',
    ar_SA: 'هل تريد إزالة المستخدم من قائمة الوكالة؟',
    tr_TR: 'Kullanıcının yönetici yetkisini kaldırmak istiyor musunuz?',
    pt_BR: 'O usuário será removido da lista de administradores da agência?',
    id_ID: 'Apakah pengguna akan dihapus dari daftar admin keluarga?',
    ru_RU: 'Подтвердите, что пользователь будет удален из списка администраторов Клуба?',
    uz_UZ: 'Foydalanuvchining kurilish admini o\'chirishni tasdiqlang?',
    fa_IR: 'کاربر حذف شود؟',
    ur_PK: 'کاربر کی حذف کرنے کے لئے کیا گیا ہے؟'
  },
  确认设置该用户为公会管理员: {
    zh_CN: '确认设置该用户为公会管理员?',
    en_US: 'Confirm that the user will be set as an agency admin?',
    ar_SA: 'هل تريد تعيين المستخدم كمشرف في الوكالة؟',
    tr_TR: 'Kullanıcıyı kuruluş yöneticisi olarak ayarlamak istiyor musunuz?',
    pt_BR: 'O usuário será definido como administrador da agência?',
    id_ID: 'Apakah pengguna akan dijadikan admin keluarga?',
    ru_RU: 'Подтвердите, что пользователь будет назначен администратором Клуба?',
    uz_UZ: 'Foydalanuvchini kurilish admini tayyorlashni tasdiqlang?',
    fa_IR: 'کاربر به عنوان مدیر کارگری شود؟',
    ur_PK: 'کاربر کی تعیین کرنے کے لئے کیا گیا ہے؟'
  },
  加载中: {
    zh_CN: '加载中…',
    en_US: 'Loading...',
    ar_SA: 'جاري التحميل...',
    tr_TR: 'Yükleniyor...',
    pt_BR: 'Carregando...',
    id_ID: 'Memuat...',
    ru_RU: 'Загрузка...',
    uz_UZ: 'Yuklanmoqda...',  
    fa_IR: 'در حال بارگذاری...',
    ur_PK: 'لودنے کا درخواست ہوئے...'
  },
  外管: {
    zh_CN: '外管',
    en_US: 'Supervisor',
    ar_SA: 'المشرف',
    tr_TR: 'Denetçi',
    pt_BR: 'Supervisor',
    id_ID: 'Pengawas',
    ru_RU: 'Супервайзер',
    uz_UZ: 'Nazoratchi',
    fa_IR: 'سرپرست',
    ur_PK: 'نگران',
  },
  操作: {
    zh_CN: '操作',
    en_US: 'Operation',
    ar_SA: 'عملية',
    tr_TR: 'İşlem',
    pt_BR: 'Operação',
    id_ID: 'Operasi',
    ru_RU: 'Операция',
    uz_UZ: 'Amal',
    fa_IR: 'عملیات',
    ur_PK: 'عمل',
  },
  发放礼包: {
    zh_CN: '发放礼包',
    en_US: 'Issue Gift Pack',
    ar_SA: 'إصدار الحزمة',
    tr_TR: 'Hediye Paketini Dağıt',
    pt_BR: 'Emitir Pacote de Presente',
    id_ID: 'Terbitkan Paket Hadiah',
    ru_RU: 'Выдать подарочный набор',
    uz_UZ: 'Sovg‘a to‘plamini berish',
    fa_IR: 'صدور بسته هدیه',
    ur_PK: 'تحفہ پیک جاری کریں',
  },
  公会申请: {
    zh_CN: '公会申请',
    en_US: 'Agency Application',
    ar_SA: 'طلب الوكالة',
    tr_TR: 'Ajans Başvurusu',
    pt_BR: 'Solicitação de Agência',
    id_ID: 'Pengajuan Agensi',
    ru_RU: 'Заявка агентства',
    uz_UZ: 'Agentlik arizasi',
    fa_IR: 'درخواست آژانس',
    ur_PK: 'ایجنسی کی درخواست',
  },
  数据查看: {
    zh_CN: '数据查看',
    en_US: 'Data View',
    ar_SA: 'عرض البيانات',
    tr_TR: 'Veri Görüntüleme',
    pt_BR: 'Visualizar Dados',
    id_ID: 'Lihat Data',
    ru_RU: 'Просмотр данных',
    uz_UZ: 'Maʼlumotlarni ko‘rish',
    fa_IR: 'مشاهده داده‌ها',
    ur_PK: 'ڈیٹا دیکھیں',
  },
  下级BD列表: {
    zh_CN: '下级BD列表',
    en_US: 'Sub BD List',
    ar_SA: 'قائمة BD الفرعية',
    tr_TR: 'Alt BD Listesi',
    pt_BR: 'Lista de BD Subordinados',
    id_ID: 'Daftar BD Bawahan',
    ru_RU: 'Список подчинённых BD',
    uz_UZ: 'Quyi BD ro‘yxati',
    fa_IR: 'فهرست BDهای زیرمجموعه',
    ur_PK: 'زیریں BD فہرست',
  },
  公会数据: {
    zh_CN: '公会数据',
    en_US: 'Agency Data',
    ar_SA: 'بيانات الوكالة',
    tr_TR: 'Ajans Verileri',
    pt_BR: 'Dados da Agência',
    id_ID: 'Data Agensi',
    ru_RU: 'Данные агентства',
    uz_UZ: 'Agentlik maʼlumotlari',
    fa_IR: 'داده‌های آژانس',
    ur_PK: 'ایجنسی ڈیٹا',
  },
  公会列表: {
    zh_CN: '公会列表',
    en_US: 'Agency List',
    ar_SA: 'قائمة الوكالات',
    tr_TR: 'Ajans Listesi',
    pt_BR: 'Lista de Agências',
    id_ID: 'Daftar Agensi',
    ru_RU: 'Список агентств',
    uz_UZ: 'Agentliklar ro‘yxati',
    fa_IR: 'فهرست آژانس‌ها',
    ur_PK: 'ایجنسیوں کی فہرست',
  },
  输入用户ID: {
    zh_CN: '输入用户ID',
    en_US: 'Enter User ID',
    ar_SA: 'أدخل معرف المستخدم',
    tr_TR: "Kullanıcı ID'si Girin",
    pt_BR: 'Digite o ID do Usuário',
    id_ID: 'Masukkan ID Pengguna',
    ru_RU: 'Введите ID пользователя',
    uz_UZ: 'Foydalanuvchi ID sini kiriting',
    fa_IR: 'شناسه کاربر را وارد کنید',
    ur_PK: 'صارف ID درج کریں',
  },
  发放记录: {
    zh_CN: '发放记录',
    en_US: 'Issue Records',
    ar_SA: 'سجلات الإصدار',
    tr_TR: 'Dağıtım Kayıtları',
    pt_BR: 'Registros de Emissão',
    id_ID: 'Riwayat Penerbitan',
    ru_RU: 'Записи выдачи',
    uz_UZ: 'Berish yozuvlari',
    fa_IR: 'سوابق صدور',
    ur_PK: 'اجراءات کے ریکارڈ',
  },
  礼包内容: {
    zh_CN: '礼包内容',
    en_US: 'Gift Pack Content',
    ar_SA: 'محتوى الحزمة',
    tr_TR: 'Hediye Paketi İçeriği',
    pt_BR: 'Conteúdo do Pacote',
    id_ID: 'Isi Paket Hadiah',
    ru_RU: 'Содержимое набора',
    uz_UZ: 'To‘plam tarkibi',
    fa_IR: 'محتوای بسته هدیه',
    ur_PK: 'تحفہ پیک کا مواد',
  },
  礼包列表: {
    zh_CN: '礼包列表',
    en_US: 'Gift Pack List',
    ar_SA: 'قائمة الحزم',
    tr_TR: 'Hediye Paket Listesi',
    pt_BR: 'Lista de Pacotes',
    id_ID: 'Daftar Paket Hadiah',
    ru_RU: 'Список наборов',
    uz_UZ: 'To‘plamlar ro‘yxati',
    fa_IR: 'فهرست بسته‌های هدیه',
    ur_PK: 'تحفہ پیک لسٹ',
  },
  礼包ID: {
    zh_CN: '礼包ID',
    en_US: 'Gift Pack ID',
    ar_SA: 'معرف الحزمة',
    tr_TR: "Hediye Paketi ID'si",
    pt_BR: 'ID do Pacote',
    id_ID: 'ID Paket Hadiah',
    ru_RU: 'ID набора',
    uz_UZ: 'To‘plam ID',
    fa_IR: 'شناسه بسته',
    ur_PK: 'پیک ID',
  },
  用户ID: {
    zh_CN: '用户ID',
    en_US: 'User ID',
    ar_SA: 'معرف المستخدم',
    tr_TR: "Kullanıcı ID'si",
    pt_BR: 'ID do Usuário',
    id_ID: 'ID Pengguna',
    ru_RU: 'ID пользователя',
    uz_UZ: 'Foydalanuvchi ID',
    fa_IR: 'شناسه کاربر',
    ur_PK: 'صارف ID',
  },
  发放: {
    zh_CN: '发放',
    en_US: 'Issue',
    ar_SA: 'إصدار',
    tr_TR: 'Dağıt',
    pt_BR: 'Emitir',
    id_ID: 'Terbitkan',
    ru_RU: 'Выдать',
    uz_UZ: 'Berish',
    fa_IR: 'صدور',
    ur_PK: 'جاری کریں',
  },
  '确认要给该用户发放礼包吗?': {
    zh_CN: '确认要给该用户发放礼包吗?',
    en_US: 'Confirm to issue a gift pack to this user?',
    ar_SA: 'تأكيد إصدار حزمة لهذا المستخدم؟',
    tr_TR: 'Bu kullanıcıya hediye paketi dağıtılsın mı?',
    pt_BR: 'Confirmar emissão de pacote de presente para este usuário?',
    id_ID: 'Konfirmasi menerbitkan paket hadiah ke pengguna ini?',
    ru_RU: 'Подтвердить выдачу подарочного набора этому пользователю?',
    uz_UZ: 'Ushbu foydalanuvchiga sovg‘a to‘plami berilsinmi?',
    fa_IR: 'صدور بسته هدیه برای این کاربر تأیید شود؟',
    ur_PK: 'کیا اس صارف کو تحفہ پیک جاری کرنا ہے؟',
  },
  发放于: {
    zh_CN: '发放于',
    en_US: 'Issued at',
    ar_SA: 'صُدر في',
    tr_TR: 'Dağıtım zamanı',
    pt_BR: 'Emitido em',
    id_ID: 'Diterbitkan pada',
    ru_RU: 'Выдано в',
    uz_UZ: 'Berilgan vaqti',
    fa_IR: 'صادر شده در',
    ur_PK: 'جاری کیا گیا',
  },
  待处理: {
    zh_CN: '待处理',
    en_US: 'Pending',
    ar_SA: 'قيد الانتظار',
    tr_TR: 'Beklemede',
    pt_BR: 'Pendente',
    id_ID: 'Tertunda',
    ru_RU: 'В ожидании',
    uz_UZ: 'Kutilmoqda',
    fa_IR: 'در انتظار',
    ur_PK: 'زیر التواء',
  },
  已处理: {
    zh_CN: '已处理',
    en_US: 'Processed',
    ar_SA: 'تمت المعالجة',
    tr_TR: 'İşlendi',
    pt_BR: 'Processado',
    id_ID: 'Diproses',
    ru_RU: 'Обработано',
    uz_UZ: 'Qayta ishlangan',
    fa_IR: 'پردازش شده',
    ur_PK: 'پراسس ہو چکا',
  },
  创建公会申请: {
    zh_CN: '创建公会申请',
    en_US: 'Agency Creation Application',
    ar_SA: 'طلب إنشاء وكالة',
    tr_TR: 'Ajans Kurma Başvurusu',
    pt_BR: 'Solicitação de Criação de Agência',
    id_ID: 'Pengajuan Pembuatan Agensi',
    ru_RU: 'Заявка на создание агентства',
    uz_UZ: 'Agentlik yaratish arizasi',
    fa_IR: 'درخواست ایجاد آژانس',
    ur_PK: 'ایجنسی بنانے کی درخواست',
  },
  批准: {
    zh_CN: '批准',
    en_US: 'Approve',
    ar_SA: 'موافقة',
    tr_TR: 'Onayla',
    pt_BR: 'Aprovar',
    id_ID: 'Setujui',
    ru_RU: 'Одобрить',
    uz_UZ: 'Maʼqullash',
    fa_IR: 'تأیید',
    ur_PK: 'منظور کریں',
  },
  '国家/地区': {
    zh_CN: '国家/地区',
    en_US: 'Country/Region',
    ar_SA: 'البلد / المنطقة',
    tr_TR: 'Ülke/Bölge',
    pt_BR: 'País/Região',
    id_ID: 'Negara/Wilayah',
    ru_RU: 'Страна/Регион',
    uz_UZ: 'Mamlakat/Hudud',
    fa_IR: 'کشور/منطقه',
    ur_PK: 'ملک/علاقہ',
  },
  经理ID: {
    zh_CN: '经理ID',
    en_US: 'Manager ID',
    ar_SA: 'معرف المدير',
    tr_TR: "Yönetici ID'si",
    pt_BR: 'ID do Gerente',
    id_ID: 'ID Manajer',
    ru_RU: 'ID менеджера',
    uz_UZ: 'Menejer ID',
    fa_IR: 'شناسه مدیر',
    ur_PK: 'منیجر ID',
  },
  创建者ID: {
    zh_CN: '创建者ID',
    en_US: 'Creator ID',
    ar_SA: 'معرف المنشئ',
    tr_TR: "Oluşturan ID'si",
    pt_BR: 'ID do Criador',
    id_ID: 'ID Pembuat',
    ru_RU: 'ID создателя',
    uz_UZ: 'Yaratgan ID',
    fa_IR: 'شناسه ایجادکننده',
    ur_PK: 'خالق ID',
  },
  创建时间: {
    zh_CN: '创建时间',
    en_US: 'Creation Time',
    ar_SA: 'وقت الإنشاء',
    tr_TR: 'Oluşturma Zamanı',
    pt_BR: 'Hora de Criação',
    id_ID: 'Waktu Pembuatan',
    ru_RU: 'Время создания',
    uz_UZ: 'Yaratilgan vaqti',
    fa_IR: 'زمان ایجاد',
    ur_PK: 'بننے کا وقت',
  },
  已通过: {
    zh_CN: '已通过',
    en_US: 'Approved',
    ar_SA: 'تمت الموافقة',
    tr_TR: 'Onaylandı',
    pt_BR: 'Aprovado',
    id_ID: 'Disetujui',
    ru_RU: 'Одобрено',
    uz_UZ: 'Tasdiqlandi',
    fa_IR: 'تأیید شده',
    ur_PK: 'منظور شدہ',
  },
  处理时间: {
    zh_CN: '处理时间',
    en_US: 'Processing Time',
    ar_SA: 'وقت المعالجة',
    tr_TR: 'İşleme Süresi',
    pt_BR: 'Tempo de Processamento',
    id_ID: 'Waktu Pemrosesan',
    ru_RU: 'Время обработки',
    uz_UZ: 'Qayta ishlash vaqti',
    fa_IR: 'زمان پردازش',
    ur_PK: 'پراسس کا وقت',
  },
  '是否同意{{id}}申请{{n}}创建?': {
    zh_CN: '是否同意{{id}}申请{{n}}创建？',
    en_US: 'Agree to {{id}} applying to create {{n}}?',
    ar_SA: 'هل توافق على طلب {{id}} لإنشاء {{n}}؟',
    tr_TR:
      '{{id}} kullanıcısının {{n}} oluşturma isteğini kabul ediyorsunuz mu?',
    pt_BR: 'Concorda com {{id}} criando {{n}}?',
    id_ID: 'Setuju {{id}} membuat {{n}}?',
    ru_RU: 'Согласиться с заявкой {{id}} на создание {{n}}?',
    uz_UZ: '{{id}} tomonidan {{n}} yaratish so‘roviga rozi bo‘lasizmi?',
    fa_IR: 'با درخواست {{id}} برای ایجاد {{n}} موافقید؟',
    ur_PK: 'کیا آپ {{id}} کی {{n}} بنانے کی درخواست مانتے ہیں؟',
  },
  '是否拒绝{{id}}申请{{n}}创建?': {
    zh_CN: '是否拒绝{{id}}申请{{n}}创建？',
    en_US: 'Reject {{id}} applying to create {{n}}?',
    ar_SA: 'هل ترفض طلب {{id}} لإنشاء {{n}}؟',
    tr_TR:
      '{{id}} kullanıcısının {{n}} oluşturma isteğini reddediyorsunuz mu?',
    pt_BR: 'Rejeitar {{id}} criando {{n}}?',
    id_ID: 'Tolak {{id}} membuat {{n}}?',
    ru_RU: 'Отклонить заявку {{id}} на создание {{n}}?',
    uz_UZ: '{{id}} ning {{n}} yaratish so‘rovini rad etasizmi?',
    fa_IR: 'آیا درخواست {{id}} برای ایجاد {{n}} را رد می‌کنید؟',
    ur_PK: 'کیا آپ {{id}} کی {{n}} بنانے کی درخواست رد کریں گے؟',
  },
  '哎呀，没有搜索结果': {
    zh_CN: '哎呀，没有搜索结果',
    en_US: 'Oops, no search results',
    ar_SA: 'عفوًا، لا توجد نتائج بحث',
    tr_TR: 'Hay aksi, arama sonucu yok',
    pt_BR: 'Ops, nenhum resultado de pesquisa',
    id_ID: 'Ups, tidak ada hasil pencarian',
    ru_RU: 'Упс, результатов поиска нет',
    uz_UZ: 'Voy, qidiruv natijalari topilmadi',
    fa_IR: 'اوه، نتیجه جستجو پیدا نشد',
    ur_PK: 'اوہ، تلاش کے نتائج نہیں ملے',
  },
  总计: {
    zh_CN: '总计',
    en_US: 'Total',
    ar_SA: 'الإجمالي',
    tr_TR: 'Toplam',
    pt_BR: 'Total',
    id_ID: 'Total',
    ru_RU: 'Итого',
    uz_UZ: 'Jami',
    fa_IR: 'مجموع',
    ur_PK: 'کل',
  },
  BD数量: {
    zh_CN: 'BD数量',
    en_US: 'BD Count',
    ar_SA: 'عدد BD',
    tr_TR: 'BD Sayısı',
    pt_BR: 'Quantidade de BD',
    id_ID: 'Jumlah BD',
    ru_RU: 'Количество BD',
    uz_UZ: 'BD soni',
    fa_IR: 'تعداد BD',
    ur_PK: 'BD کی تعداد',
  },
  公会数量: {
    zh_CN: '公会数量',
    en_US: 'Agency Count',
    ar_SA: 'عدد الوكالات',
    tr_TR: 'Ajans Sayısı',
    pt_BR: 'Quantidade de Agências',
    id_ID: 'Jumlah Agensi',
    ru_RU: 'Количество агентств',
    uz_UZ: 'Agentliklar soni',
    fa_IR: 'تعداد آژانس‌ها',
    ur_PK: 'ایجنسیوں کی تعداد',
  },
  'BD ID': {
    zh_CN: 'BD ID',
    en_US: 'BD ID',
    ar_SA: 'معرف BD',
    tr_TR: 'BD ID',
    pt_BR: 'ID do BD',
    id_ID: 'ID BD',
    ru_RU: 'BD ID',
    uz_UZ: 'BD ID',
    fa_IR: 'شناسه BD',
    ur_PK: 'BD ID',
  },
  BD中心: {
    zh_CN: 'BD中心',
    en_US: 'BD Center',
    ar_SA: 'مركز BD',
    tr_TR: 'BD Merkezi',
    pt_BR: 'Centro de BD',
    id_ID: 'Pusat BD',
    ru_RU: 'Центр BD',
    uz_UZ: 'BD markazi',
    fa_IR: 'مرکز BD',
    ur_PK: 'BD مرکز',
  },
  你的上级管理: {
    zh_CN: '你的上级管理',
    en_US: 'Your Upper Management',
    ar_SA: 'إدارتك العليا',
    tr_TR: 'Üst Yönetiminiz',
    pt_BR: 'Sua Gestão Superior',
    id_ID: 'Manajemen Atas Anda',
    ru_RU: 'Ваше руководство',
    uz_UZ: 'Sizning yuqori rahbariyatingiz',
    fa_IR: 'مدیران بالادستی شما',
    ur_PK: 'آپ کی بالادست مینجمنٹ',
  },
  代理ID: {
    zh_CN: '代理ID',
    en_US: 'Agent ID',
    ar_SA: 'معرف الوكيل',
    tr_TR: "Temsilci ID'si",
    pt_BR: 'ID do Agente',
    id_ID: 'ID Agen',
    ru_RU: 'ID агента',
    uz_UZ: 'Agent ID',
    fa_IR: 'شناسه نماینده',
    ur_PK: 'ایجنٹ ID',
  },
  下级公会数据: {
    zh_CN: '下级公会数据',
    en_US: 'Sub Agency Data',
    ar_SA: 'بيانات الوكالات الفرعية',
    tr_TR: 'Alt Ajans Verileri',
    pt_BR: 'Dados de Agências Subordinadas',
    id_ID: 'Data Agensi Bawahan',
    ru_RU: 'Данные подчинённых агентств',
    uz_UZ: 'Quyi agentliklar maʼlumotlari',
    fa_IR: 'داده‌های آژانس‌های زیرمجموعه',
    ur_PK: 'زیریں ایجنسیوں کا ڈیٹا',
  },
  个人数据: {
    zh_CN: '个人数据',
    en_US: 'Personal',
    ar_SA: 'شخصي',
    tr_TR: 'Kişisel',
    pt_BR: 'Pessoal',
    id_ID: 'Pribadi',
    ru_RU: 'Личный',
    uz_UZ: 'Shaxsiy',
    fa_IR: 'شخصی',
    ur_PK: 'ذاتی',
  },
  BD: {
    zh_CN: 'BD',
    en_US: 'BD',
    ar_SA: 'BD',
    tr_TR: 'BD',
    pt_BR: 'BD',
    id_ID: 'BD',
    ru_RU: 'BD',
    uz_UZ: 'BD',
    fa_IR: 'BD',
    ur_PK: 'BD',
  },
  活跃主播数: {
    zh_CN: '活跃主播数',
    en_US: 'Active Hosts',
    ar_SA: 'المضيفون النشطون',
    tr_TR: 'Aktif Yayıncılar',
    pt_BR: 'Streamers Ativos',
    id_ID: 'Host Aktif',
    ru_RU: 'Активные ведущие',
    uz_UZ: 'Faol boshlovchilar',
    fa_IR: 'میزبانان فعال',
    ur_PK: 'فعال میزبان',
  },
  产出钻石总数: {
    zh_CN: '产出钻石总数',
    en_US: 'Total Diamonds Generated',
    ar_SA: 'إجمالي الماس الناتج',
    tr_TR: 'Üretilen Toplam Elmas',
    pt_BR: 'Total de Diamantes Gerados',
    id_ID: 'Total Berlian Dihasilkan',
    ru_RU: 'Всего сгенерировано алмазов',
    uz_UZ: 'Ishlab chiqarilgan jami olmoslar',
    fa_IR: 'مجموع الماس‌های تولید شده',
    ur_PK: 'کل ہیرے پیدا ہوئے',
  },
  编辑: {
    zh_CN: '编辑',
    en_US: 'Edit',
    ar_SA: 'تعديل',
    tr_TR: 'Düzenle',
    pt_BR: 'Editar',
    id_ID: 'Edit',
    ru_RU: 'Редактировать',
    uz_UZ: 'Tahrirlash',
    fa_IR: 'ویرایش',
    ur_PK: 'ترمیم کریں',
  },
  请再次确认您的上级管理为: {
    zh_CN: '请再次确认您的上级管理为',
    en_US: 'Please confirm again that your superior manager is',
    ar_SA: 'يرجى التأكيد مرة أخرى أن مديرك الأعلى هو',
    tr_TR: 'Lütfen üst yöneticinizin şu kişi olduğunu tekrar onaylayın',
    pt_BR: 'Por favor, confirme novamente se o seu gerente superior é',
    id_ID: 'Silakan konfirmasi lagi bahwa manajer atasan Anda adalah',
    ru_RU: 'Пожалуйста, подтвердите еще раз, что вашим руководителем является',
    uz_UZ: 'Iltimos, rahbaringiz kim ekanligini yana bir bor tasdiqlang',
    fa_IR: 'لطفاً دوباره تأیید کنید که مدیر ارشد شما',
    ur_PK: 'براہ کرم دوبارہ تصدیق کریں کہ آپ کا اعلیٰ مینیجر ہے',
  },
  代理: {
    zh_CN: '代理',
    en_US: 'Agent',
    ar_SA: 'الوكيل',
    tr_TR: 'Temsilci',
    pt_BR: 'Agente',
    id_ID: 'Agen',
    ru_RU: 'Агент',
    uz_UZ: 'Agent',
    fa_IR: 'نماینده',
    ur_PK: 'ایجنٹ',
  },
  我的金币: {
    zh_CN: '我的金币',
    en_US: 'My Coins',
    ar_SA: 'المعادن',
    tr_TR: 'Benim Miktar',
    pt_BR: 'Meus Moedas',
    id_ID: 'Uang Saya',
    ru_RU: 'Мои монеты',
    uz_UZ: 'Mening jami',
    fa_IR: 'موجودی من',
  },
  分配: {
    zh_CN: '分配',
    en_US: 'Distribute',
    ar_SA: 'توزيع',
    tr_TR: 'Dağıt',
    pt_BR: 'Distribuir',
    id_ID: 'Terdistribusi',
    ru_RU: 'Распределить',
    uz_UZ: 'Bajarish',
    fa_IR: 'توزیع',
  },
  充值: {
    zh_CN: '充值',
    en_US: 'Recharge',
    ar_SA: 'إعادة تسليم',
    tr_TR: 'Yenile',
    pt_BR: 'Recarregar',
    id_ID: 'Isi ulang',
    ru_RU: 'Переплатить',
    uz_UZ: 'Qaytadan olish',
    fa_IR: 'شارژ',
  },
  请输入转账用户ID: {
    zh_CN: '请输入转账用户ID',
    en_US: 'Enter the transfer user ID',
    ar_SA: 'أدخل معرف المستخدم الذي تريد إرسال التحويل',
    tr_TR: 'Transfer kullanıcı ID\'sini giriniz',
    pt_BR: 'Digite o ID do usuário para transferência',
    id_ID: 'Masukkan ID pengguna penerima transfer',
    ru_RU: 'Введите ID пользователя, которому нужно перевести средства',
    uz_UZ: 'Transfer uchun foydalanuvchi ID ni kiriting',
    fa_IR: 'شناسه کاربری انتقال را وارد کنید',
  },
  请输入用户ID: {
    zh_CN: '请输入用户ID',
    en_US: 'Enter the user ID',
    ar_SA: 'أدخل معرف المستخدم',
    tr_TR: 'Kullanıcı ID\'sini giriniz',
    pt_BR: 'Digite o ID do usuário',
    id_ID: 'Masukkan ID pengguna',
    ru_RU: 'Введите ID пользователя',
    uz_UZ: 'Foydalanuvchi ID ni kiriting',
    fa_IR: 'شناسه کاربری را وارد کنید',
  },
  '该ID不存在,请重新输入': {
    zh_CN: '该ID不存在,请重新输入',
    en_US: 'The ID does not exist, please re-enter',
    ar_SA: 'هذا الرقم غير موجود، يرجى إعادة إدخاله',
    tr_TR: 'Bu ID bulunmuyor, lütfen tekrar giriniz',
    pt_BR: 'O ID não existe, por favor insira novamente',
    id_ID: 'ID tidak ada, silakan masukkan kembali',
    ru_RU: 'Такого ID не существует, пожалуйста, введите заново',
    uz_UZ: 'ID mavjud emas, qayta kiriting',
    fa_IR: 'این شناسه وجود ندارد، لطفاً دوباره وارد کنید',
    ur_PK: 'این ID وجود نہیں ہے، دوبارہ ورود کریں',
  },
  请输入转账金额: {
    zh_CN: '请输入转账金额',
    en_US: 'Enter the transfer amount',
    ar_SA: 'أدخل مبلغ التحويل',
    tr_TR: 'Transfer miktarını giriniz',
    pt_BR: 'Digite o valor da transferência',
    id_ID: 'Masukkan jumlah transfer',
    ru_RU: 'Введите сумму перевода',
    uz_UZ: 'Transfer miqdori kiriting',
    ur_PK: 'انتقالی مقدار را وارد کریں',
  },
  请输入金额: {
    zh_CN: '请输入金额',
    en_US: 'Enter the amount',
    ar_SA: 'أدخل المبلغ',
    tr_TR: 'Miktarı giriniz',
    pt_BR: 'Digite o valor',
    id_ID: 'Masukkan jumlah',
    ru_RU: 'Введите сумму',
    uz_UZ: 'Miqdori kiriting',
    fa_IR: 'مبلغ را وارد کنید',
    ur_PK: 'مقدار را وارد کریں',
  },
  选择支付方式: {
    zh_CN: '选择支付方式',
    en_US: 'Select Payment Method',
    ar_SA: 'اختر طريقة الدفع',
    tr_TR: 'Ödeme Yöntemini Seçin',
    pt_BR: 'Selecione o Método de Pagamento',
    id_ID: 'Pilih Metode Pembayaran',
    ru_RU: 'Выберите способ оплаты',
    uz_UZ: "To'lov uslubi tanlang",
    fa_IR: 'انتخاب روش پرداخت',
    ur_PK: 'پرداختی را انتخاب کریں',
  },
  金币不足: {
    zh_CN: '金币不足',
    en_US: 'Insufficient Coins',
    ar_SA: 'المعادن غير كافية',
    tr_TR: 'Yetersiz Miktar',
    pt_BR: 'Moedas Insuficientes',
    id_ID: 'Jumlah Koin yang tidak cukup',
    ru_RU: 'Недостаточно монет',
    uz_UZ: 'Jami miqdori kamchilik',
    fa_IR: 'کیفیت کمتر از حد',
    ur_PK: 'کیفیت کمتر از حد',
  },
  转账成功: {
    zh_CN: '转账成功',
    en_US: 'Transfer Success',
    ar_SA: 'تحويل ناجح',
    tr_TR: 'Transfer Başarılı',
    pt_BR: 'Transferência Concluída',
    id_ID: 'Transfer Berhasil',
    ru_RU: 'Перевод успешно выполнен',
    uz_UZ: 'Transfer uchun muvaffaqiyatli',
    fa_IR: 'انتقال موفق',
    ur_PK: 'انتقال کامیاب',
  },
  '确认给该用户转账{{n}}金币吗':  {
    zh_CN: '确认给该用户转账{{n}}金币吗?',
    en_US: 'Confirm to transfer {{n}} coins to this user?',
    ar_SA: 'هل تريد تحويل {{n}} معادن إلى هذا المستخدم؟',
    tr_TR: '{{n}} koin transfer etmek istiyor musunuz?',
    pt_BR: 'Confirma para transferir {{n}} moedas para este usuário?',
    id_ID: 'Apakah Anda yakin ingin mengirim {{n}} koin kepada pengguna ini?',
    ru_RU: 'Подтвердите перевод на {{n}} монет пользователю?',
    uz_UZ: "{{n}} so'mlik transfer etishni tasdiqlang?",
    fa_IR: 'این کاربر را به {{n}} کیف پول انتقال کنید؟',
    ur_PK: 'اس صارف کو {{n}} سونے کے سکوں کی منتقلی کی تصدیق کریں؟',
  },
  '确认给该用户转账{{n}}代理金币吗': {
    zh_CN: '确认给该用户转账{{n}}代理金币吗?',
    en_US: 'Confirm transfer of {{n}} agent coins to this user?',
    ar_SA: 'هل تريد تحويل {{n}} معادن الوكيل إلى هذا المستخدم؟',
    tr_TR: '{{n}} arac koin transfer etmek istiyor musunuz?',
    pt_BR: 'Confirma transferência de {{n}} moedas do agente para este usuário?',
    id_ID: 'Apakah Anda yakin ingin mengirim {{n}} koin arsip kepada pengguna ini?',
    ru_RU: 'Подтвердите перевод на {{n}} монет агенту пользователю?',
    uz_UZ: "{{n}} agent pulni transfer etishni tasdiqlang?",
    fa_IR: 'این کاربر را به {{n}} کیف پول وکیل انتقال کنید؟',
    ur_PK: 'اس صارف کو {{n}} سونے کے سکوں کی وکیل کی منتقلی کی تصدیق کریں؟',
  },
  '此用户是你的二级代理，本次他会收到代理金币': {
    zh_CN: 'Tips:此用户是你的二级代理，本次他会收到代理金币',
    en_US:
      'Tips: This user is your second-level agent. They will receive agent coins this time.',
    ar_SA: 'ملاحظة: هذا المستخدم هو وكيلك من المستوى الثاني. سيحصل على عملات الوكيل هذه المرة.',
    tr_TR: 'İpucu: Bu kullanıcı senin ikinci seviye aracı. Bu sefer aracı miktarları alacak.',
    pt_BR: 'Dicas: Este usuário é seu segundo agente. Eles receberão moedas do agente nesta vez.',
    id_ID: 'Tips: Pengguna ini adalah agen kedua Anda. Mereka hanya menerima uang arsip sekarang.',
    ru_RU: 'Подсказка: Этот пользователь - ваш второй уровень агента. Он получит агентские монеты в этот раз.',
    uz_UZ: "Qo'shimcha: Bu foydalanuvchi sizning ikkinchi arzda agent. Ushbu marta agentlar pulini olishi mumkin.",
    fa_IR: 'توصیه: این کاربر یکی از مدیران دوم شما می باشد. این بار آنها کیف پول های وکیل دریافت خواهد کرد.',
    ur_PK: 'توجہ: این صارف دوم سے کیف پول انتقال کرنے کی اجازت دیتے ہیں. این بار آن کیف پول وکیل کی کسی بھی کسی بھی ہوتا ہے.',
  },
  上级币商: {
    zh_CN: '上级币商',
    en_US: 'Upper-level coin traders',
    ar_SA: 'المتاجر العلوية',
    tr_TR: 'Üst seviye coin alimleri',
    pt_BR: 'Traders de moedas superiores',
    id_ID: 'Penjual coin atas',
    ru_RU: 'Вышеуровневые трейдеры',
    uz_UZ: 'Yuqori arzda pulni olish uchun',
    fa_IR: 'مدیران بالاتر',
    ur_PK: 'اعلی درجے کے سکے کے تاجر'
  },
  '您的订单正在处理中，请稍候': {
    zh_CN: '您的订单正在处理中，请稍候。',
    en_US: 'Your order is being processed, please wait.',
    ar_SA: 'تم تنفيذ طلبك، يرجى الانتظار.',
    tr_TR: 'Siparişiniz işleniyor, lütfen bekleyin.',
    pt_BR: 'Seu pedido está sendo processado, por favor aguarde.',
    id_ID: 'Pesanan Anda sedang diproses, mohon tunggu.',
    ru_RU: 'Ваш заказ обрабатывается, пожалуйста, подождите.',
    uz_UZ: 'Sizning buyurtmangiz olib ketdi, keyinroq urinib ko\'ring.',
    fa_IR: 'سفارش شما در حال پردازش می باشد، لطفا منتظر بمانید.',
    ur_PK: 'سیٹرنا کی کار کر دیا گیا، منتظر کرنے کے لئے ہے.'
  },
  代理金币账单: {
    zh_CN: '代理金币账单',
    en_US: 'Agent Gold Coin Bill',
    ar_SA: 'فاتورة معادن الوكيل',
    tr_TR: 'Arac Gold Coin Fatura',
    pt_BR: 'Nota de Moedas do Agente',
    id_ID: 'Tagihan Koin Arsip',
    ru_RU: 'Счет агентского золота',
    uz_UZ: 'Agent Gold Coin Fatura',
    fa_IR: 'فاکتور معادن وکیل',
    ur_PK: 'وکیل کی سونے کے سکوں کی فاکتور'
  },
  '给该用户转账了{{n}}金币': {
    zh_CN: '给该用户转账了{{n}}金币',
    en_US: 'Transferred {{n}} coins to this user',
    ar_SA: 'تم تحويل {{n}} معادن إلى هذا المستخدم',
    tr_TR: '{{n}} koin transfer edildi',
    pt_BR: 'Transferiu {{n}} moedas para este usuário',
    id_ID: 'Mengirim {{n}} koin kepada pengguna ini',
    ru_RU: 'Переведено {{n}} монет пользователю',
    uz_UZ: "{{n}} so'mlik transfer etildi",
    fa_IR: 'انتقال {{n}} کیف پول به این کاربر',
    ur_PK: 'انتقال {{n}} سونے کے سکوں کی صارف'
  },
  '收到上级币商的{{n}}代理金币': {
    zh_CN: '收到上级币商的{{n}}代理金币',
    en_US: 'Received {{n}} agent gold coins from the superior coin merchant',
    ar_SA: 'تلقى {{n}} معادن طفل من المتاجر العلوية',
    tr_TR: '{{n}} arac gold coin alındı',
    pt_BR: 'Recebeu {{n}} moedas de ouro do agente superior', 
    id_ID: 'Menerima {{n}} koin emas dari penjual coin atas',
    ru_RU: 'Получено {{n}} монет агентского золота от вышеуровневого трейдера',
    uz_UZ: "{{n}} agent pulni olish uchun o'zingizga emas pulni olib ketdi",
    fa_IR: 'دریافت کردن {{n}} کیف پول وکیل از مدیران بالاتر',
    ur_PK: 'اعلی سکے کے تاجر سے {{n}} ایجنٹ سونے کے سکے موصول ہوئے۔',
  },
  '给该二级币商转账了{{n}}代理金币': {
    zh_CN: '给该二级币商转账了{{n}}代理金币',
    en_US: '{{n}} agent coins were transferred to the secondary dealer.',
    ar_SA: 'تم تحويل {{n}} معادن الوكيل إلى التاجر الثاني.',
    tr_TR: '{{n}} arac koinlar ikincil tedarikçe iletilmiştir.',
    pt_BR: '{{n}} moedas do agente foram transferidas para o dealer secundário.',
    id_ID: '{{n}} koin arsip dikirim kepada dealer lain.',
    ru_RU: 'Переведено {{n}} монет агенту вторичному дилеру.',
    uz_UZ: "{{n}} agent pulni ikkinchi tedarikchi bilan transfer etildi.",
    fa_IR: '{{n}} کیف پول وکیل به دیگر دارنده های ثانویه انتقال شد.',
    ur_PK: 'انتقال {{n}} سونے کے سکوں کی وکیل کی دیگر دارنده ہوئے۔',
  },
  确认: {
    zh_CN: '确认',
    en_US: 'Confirm',
    ar_SA: 'تأكيد',
    tr_TR: 'Onayla',
    pt_BR: 'Confirmar',
    id_ID: 'Konfirmasi',
    ru_RU: 'Подтвердить',
    uz_UZ: 'Tasdiqlash',
    fa_IR: 'تایید',
    ur_PK: 'تصدیق کریں'
  },
  复制成功: {
    zh_CN: '复制成功',
    en_US: 'Copied successfully',
    ar_SA: 'تم نسخ البيانات بنجاح',
    tr_TR: 'Veri kopyalandı',
    pt_BR: 'Dados copiados com sucesso',
    id_ID: 'Data disimpan',
    ru_RU: 'Данные скопированы',
    uz_UZ: 'Muvaffaqiyatli nusxa olindi',
    fa_IR: 'کپی شد',
    ur_PK: 'کپی شد'
  },
  // TODO 官网相关的
  国家和地区: {
    zh_CN: '国家 / 地区',
    en_US: 'Country / Region',
    ar_SA: 'الدولة / المنطقة',
    tr_TR: 'Ülke / Alan',
    pt_BR: 'País / Região',
    id_ID: 'Negara / Daerah',
    ru_RU: 'Страна / Регион',
    uz_UZ: 'Davlat / Resmi',
    fa_IR: 'کشور / مسیر',
    ur_PK: 'کشور / مسیر',
  },
  请输入: {
    zh_CN: '请输入',
    en_US: 'Enter',
    ar_SA: 'ادخل',
    tr_TR: 'Gir',
    pt_BR: 'Entrar',
    id_ID: 'Masukkan',
    ru_RU: 'Ввести',
    uz_UZ: 'Kiritish',
    fa_IR: ' وارد شد',
    ur_PK: 'اپ ہیں وارد کریں',
  },
  官网充值提示: {
    zh_CN: '请确认您输入的SouLike ID是正确的。',
    en_US: 'Please confirm that the SouLike ID you entered is correct. ',
    ar_SA: 'يرجى التأكد من أن معرف SouLike الذي أدخلته صحيح.',
    tr_TR: "Lütfen girdiğiniz SouLike ID'nin doğru olduğundan emin olun.",
    pt_BR: 'Por favor, confirme se o ID SouLike inserido está correto.',
    id_ID: 'Harap konfirmasi bahwa ID SouLike yang Anda masukkan benar.',
    ru_RU: 'Пожалуйста, убедитесь, что введенный вами SouLike ID верен.',
    uz_UZ: 'Iltimos, kiritilgan SouLike ID to‘g‘ri ekanligini tasdiqlang.',
    fa_IR: 'لطفاً تأیید کنید که شناسه SouLike وارد شده صحیح است.',
    ur_PK: 'براہ کرم تصدیق کریں کہ آپ کا درج کردہ SouLike ID درست ہے۔',
  },
  继续: {
    zh_CN: '继续',
    en_US: 'Continue',
    ar_SA: 'أمر',
    tr_TR: 'Devam et',
    pt_BR: 'Continuar',
    id_ID: 'Lanjutkan',
    ru_RU: 'Продолжить',
    uz_UZ: 'Kontinua',
    fa_IR: 'تایید',
    ur_PK: 'تایید',
  },
  更换: {
    zh_CN: '更换',
    en_US: 'Switch',
    ar_SA: 'Switch',
    tr_TR: 'Switch',
    pt_BR: 'Switch',
    id_ID: 'Switch',
    ru_RU: 'Смена',
    uz_UZ: 'Qaytarish',
    fa_IR: 'Switch',
    ur_PK: 'Switch',
  },
  支付方式: {
    en_US: 'Payment Method',
    ar_SA: 'طريقة الدفع',
    tr_TR: 'Ödeme Yöntemi',
    pt_BR: 'Método de Pagamento',
    id_ID: 'Metode Pembayaran',
    ru_RU: 'Способ оплаты',
    uz_UZ: 'To‘lov usuli',
    fa_IR: 'روش پرداخت',
    ur_PK: 'ادائیگی کا طریقہ',
    zh_CN: '支付方式',
  },
  充值金额: {
    en_US: 'Recharge Amount',
    ar_SA: 'مبلغ الشحن',
    tr_TR: 'Yükleme Tutarı',
    pt_BR: 'Valor de Recarga',
    id_ID: 'Jumlah Isi Ulang',
    ru_RU: 'Сумма пополнения',
    uz_UZ: 'To‘ldirish miqdori',
    fa_IR: 'مبلغ شارژ',
    ur_PK: 'ریچارج کی رقم',
    zh_CN: '充值金额',
  },
  官网首页标题: {
    zh_CN: '寻找你的灵魂伴侣',
    en_US: 'Find Your Soulmate',
    ar_SA: 'ابحث عن توأم روحك',
    tr_TR: 'Ruh Eşini Bul',
    pt_BR: 'Find Your Soulmate',
    id_ID: 'Find Your Soulmate',
    ru_RU: 'Найди свою вторую половинку',
    uz_UZ: "O'zingizning juftingizni toping",
    fa_IR: 'Find Your Soulmate',
    ur_PK: 'Find Your Soulmate',
  },
  官网首页描述: {
    zh_CN: '使用 Voice Club，您可以以简单可靠的方式与世界各地的人交谈并结交朋友。',
    en_US: 'Using Voice Club, you can talk and make friends with people all around the world, in simple and reliable way.',
    ar_SA: 'باستخدام Voice Club، يمكنك التحدث وتكوين صداقات مع أشخاص من جميع أنحاء العالم، بطريقة بسيطة وموثوقة.',
    tr_TR: "Voice Club'ı kullanarak, dünyanın her yerinden insanlarla basit ve güvenilir bir şekilde konuşabilir ve arkadaş olabilirsiniz.",
    pt_BR: 'Using Voice Club, you can talk and make friends with people all around the world, in simple and reliable way.',
    id_ID: 'Using Voice Club, you can talk and make friends with people all around the world, in simple and reliable way.',
    ru_RU: 'Используя Voice Club, вы можете общаться и заводить друзей с людьми со всего мира простым и надежным способом.',
    uz_UZ: "Voice Club yordamida butun dunyodagi odamlar bilan oddiy va ishonchli tarzda suhbatlashishingiz va do'stlashishingiz mumkin.",
    fa_IR: 'Using Voice Club, you can talk and make friends with people all around the world, in simple and reliable way.',
    ur_PK: 'Using Voice Club, you can talk and make friends with people all around the world, in simple and reliable way.',
  },
  官网首页谷歌标题: {
    zh_CN: 'GET IT ON',
    en_US: 'GET IT ON',
    ar_SA: 'احصل عليه من',
    tr_TR: 'ŞURADAN ALIN:',
    pt_BR: 'GET IT ON',
    id_ID: 'GET IT ON',
    ru_RU: 'ДОСТУПНО В',
    uz_UZ: 'YUKLAB OLISH:',
    fa_IR: 'GET IT ON',
    ur_PK: 'GET IT ON',
  },
  下载: {
    zh_CN: '下载',
    en_US: 'Download',
    ar_SA: 'تنزيل',
    tr_TR: 'İndir',
    pt_BR: 'Download',
    id_ID: 'Download',
    ru_RU: 'Скачать',
    uz_UZ: 'Yuklab olish',
    fa_IR: 'Download',
    ur_PK: 'Download',
  },
  官网首页安卓标题: {
    zh_CN: '(.apk 文件)',
    en_US: '(.apk File)',
    ar_SA: '(ملف .apk)',
    tr_TR: '(.apk Dosyası)',
    pt_BR: '(.apk File)',
    id_ID: '(.apk File)',
    ru_RU: '(Файл .apk)',
    uz_UZ: '(.apk Fayl)',
    fa_IR: '(.apk File)',
    ur_PK: '(.apk File)',
  },
  服务协议: {
    zh_CN: '服务协议',
    en_US: 'Terms of Service',
    ar_SA: 'شروط الخدمة',
    tr_TR: 'Hizmet Şartları',
    pt_BR: 'Terms of Service',
    id_ID: 'Terms of Service',
    ru_RU: 'Условия обслуживания',
    uz_UZ: "Xizmat ko'rsatish shartlari",
    fa_IR: 'Terms of Service',
    ur_PK: 'Terms of Service',
  },
  隐私政策: {
    zh_CN: '隐私政策',
    en_US: 'Privacy Policy',
    ar_SA: 'سياسة الخصوصية',
    tr_TR: 'Gizlilik Politikası',
    pt_BR: 'Privacy Policy',
    id_ID: 'Privacy Policy',
    ru_RU: 'Политика конфиденциальности',
    uz_UZ: 'Maxfiylik siyosati',
    fa_IR: 'Privacy Policy',
    ur_PK: 'Privacy Policy',
  },
};


export default locales;